import {
  faCheck,
  faEdit,
  faInfoCircle,
  faRedo,
  faSave,
  faTimes,
  faFolder,
  faAdd,
  faTrash,
  faRightLeft,
  faDownload
} from '@fortawesome/free-solid-svg-icons';
import { faArrowAltCircleLeft, faCopy } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChangeEvent, useEffect, useMemo, useRef, useState } from 'react';
import { Button, Card, Dropdown, Form, Modal, OverlayTrigger, Popover } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  useLocation,
  matchPath,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { AppDispatch, RootState } from '../../template/store';
import { updateBlDetailsRowColumns } from '../../blDetails/slices/blDetailsTable';
import { IDataTableColumn } from '../../../common/types/dataTable';
import DataTable from '../../../common/components/DataTable';
import { toggleDocumentHistoryColumnShort } from '../../blDetails/slices/documentHistorySlice';
import {
  getDemurrage,
  addDemurrage,
  getDemurrageView,
  getInstructionList,
  getReleaseTypeList,
  getTrukerNameList,
  getDefoultPickuLocation,
  getOBLDetails,
  getAttachmentsOnly,
  getReleasePOPDetails,
  getUnpaidInvoice,
  getCFSNameList,
  fetchCFSNameByCountry,
  fetchEmptyYardNameByCountry,
  getRequestInstructionConfig,
  getLastestExtensionRequest,
  getDeliveryOrderDataForExtension,
  getPaymentReceiptsForDO,
  getApprovalLevels,
  updateIsProcessingFlag,
  getUnstuffingTypeList,
  getLinerConfigByFieldName,
  getInstructionDocTemplates,
  getRequestInstructionConfigByType,
  getApprovalConfigByInstructionName,
  checkUnpaidInvoices,
  // getCheckList,
} from '../../dashboard/actions/instruction';

import infiniteLoop from '../../../../assets/img/animated-icons/infinite-loop.json';
import * as Yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { AESDecrypt, AESEncrypt, encryptAndEncode } from '../../../../encrypt-util';
import { toast } from 'react-toastify';
import {
  updateSelectedDateDV,
  updateSelectedtruckerCode,
  updateSelectedAttachmentName,
  updateSelectedDocId,
  updateAdttamentData,
  updateSelectedPickupLocation,
  updateSelectedTruckerName,
  updateSelectedtruckerId,
  updateselectedInternalCode,
  updateSelectedAttachmentFilePath,
  updateSelectedFileServerPath,
  clearSelectedFileServerPath,
  updateLinerVerify,
  updateSelectedCheckList,
  updateselectedCheckListRemark,
  setLinerAttachment,
  updateSelectedCfsName,
  updateSelectedCfsName216,
  updateSelectedemptyYardName,
  updateListByRowNumber,
  addDocument,
  removeDocument,
  clearFields,
  clearReceiptDocList,
  clearPickupLocation,
  updateDocumentMandatoryByDocId,
} from './instructionSlice/DemurrageSlice';
import { resetDemurrageViewSlice } from './instructionSlice/DemurrageViewSlice';
import { updateDemurrageList } from './instructionSlice/DemurrageSlice';
import { useAsyncDebounce } from 'react-table';
import AsyncSelect from 'react-select/async';
import { commonApproveReject } from '../../dashboard/actions/instruction';
import Lottie from 'lottie-react';
import { getDateFormat, getDateTimeFormat } from '../../../../helpers/dateFormat';
import axiosInstance from '../../../../axiosSetup';

import { getAppConfig } from '../../../common/actions/userDetails';
import { useBackNavigation } from '../../../../hooks/BackNavigation';
import useDataCountry from '../../../../hooks/useDataCountry';
import SnoozedToButton from '../../instructionDashboard/components/SnoozedTo';
import { updateDashbaordRefresh } from '../../../common/components/DataTable/slices/DataTable';
import ToggleDiv from '../../../../components/common/ToggleDiv';
import { clearPOPLInerData, clearUnpaidData } from '../../crrpop/InvoiceUnpaidSlice';
import { getReleaseAttConf } from './actions/Instruction';
import UploadThing from '../../../../components/common/UploadThing';
import Select from 'react-select';
import useBlCountry from '../../../../hooks/useBlCountry';
import { getUnprefixedPathname } from '../../../../helpers/utils';
import { isEmptyYardDisabledByUnstuffing } from './DOExtension/utils/doExtensionUtils';
import { getReleaseInstructionCountryConfig } from './DOExtension/config';
import UnsavedChangesModal from '../../../../components/common/UnsavedChangesModal';
import { useFormNavigationWarning } from '../../../../hooks/useFormNavigationWarning';
import { setDirty } from '../../formDirtySlice';

import { extensionTypeList } from '../../dashboard/actions/instruction';

import { updateNavigateFlag, updateSelectedContainerNo, updateSelectedneedExtensionFor } from './instructionSlice/OverstayExtensionSlice';
import useConsole from '../../../../hooks/useConsole';
import { useLinerConfig } from '../../../../hooks/useLinerConfig';
import { getTncConsent } from '../../ebl/actions/eBLActions';
import Flex from '../../../../components/common/Flex';
import { Link } from 'react-router-dom';
import { useLoading } from '../../../../middleware/loadingMiddleware';
import { log } from 'console';
import { openDocumentInNewTab } from '../../../../helpers/openDocumentInNewTab';



const ReleaseInstruction = () => {
  const formRef = useRef<HTMLFormElement>(null);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [submitFlag, setSubmitFlag] = useState(false);
  const [currStatus, setcurrStatus] = useState<any>('');
  const [isEdit, setIsEdit] = useState(false);
  const [blNumDisplay, setBlNumDisplay] = useState('');
  const [isSavedDoNumber, setIsSavedDoNumber] = useState(false); // flag if DO number popluated from backend for extension
  // const [doNumber, setDoNumber] = useState('');
  const oblNumber = useSelector((x: RootState) => x.oblDetails.oblForm.number)
  //const bl_event_id = AESDecrypt(blEventId)
  //const bl_event_id = AESDecrypt(blEventId)
  const [attachedFileSize, setAttachedFileSize] = useState(0);
  const [loadingFileState, setLoadingFileState] = useState<{
    [key: string]: number;
  }>({});
  const [doExtensionSoftStopConfig, setDoExtensionConfig] = useState('No');
  const [DoExtensonCheckBoxShow, setDoExtensonCheckBoxShow] = useState('No');
  const [doGeneratedAmsConfig, setDoGeneratedAmsConfig] = useState('N');
  const [extensionInvoiceCheck, setExtensionInvoiceCheck] = useState('N');
  const [showUnstuffingTypeConfig, setShowUnstuffingTypeConfig] = useState('No');
  const [unstuffingTypeOptions, setUnstuffingTypeOptions] = useState<any[]>([]);
  const [cfsOrEmptyYardByLocationConfig, setCfsOrEmptyYardByLocationConfig] = useState('No');

  const [showPickupLocationFields, setShowPickupLocationFields] = useState(true);
  // const [DoUploadStatusShow, setDoUploadStatusShow] = useState('No');
  const [showDoUploadStatus, setShowDoUploadStatus] = useState(false);


  const [isDemurrageRequestAbsent, setShowDemurrgaeOrDeliveryModal] = useState(false);
  const [submitOn, setSubmitOn] = useState(false);
  const [isProcessing, setIsProcessing] = useState<string>('');
  const [isCfsYardDisabled, setIsCfsYardDisabled] = useState<string>('');

  // Stub: Replace with real check for whether Detention/Demurrage Invoice Instruction is submitted
  const isInvoiceInstructionSubmitted = false; // TODO: Replace with real logic
  //dndInstructionId/edi
  // const docId = getUnprefixedPathname().split('/')[4];
  const { blNum, encrypt, encryptdoc, blId } = useParams();
  const instructionLoading = useLoading(['instruction/getDemurrageView'])
  const [templateList, setTemplateList] = useState<any[]>([]);
  
  const validationSchema = Yup.object().shape({
    senderEmail: Yup.string()
      .email('Email is invalid')
      .when('country', {
        is: 'USA',
        then: Yup?.string().required('Email is required'),
      })
      .when('country', {
        is: 'CAN',
        then: Yup?.string().required('Email is required'),
      }),
    doNumber: Yup.string().when('doExtension', {
      is: 'Y',
      then: Yup.string().required('DO Number is required when DO extension is selected'),
      otherwise: Yup.string().notRequired(),
    }),
      // destuffingType: Yup.string().required('Destuffing Type  is required'),
  });

  //console.log("templateList",templateList)


  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    setError,
    watch,
    control,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  });
  const ShowInvoiceModal = isDemurrageRequestAbsent && watch('doExtension') == 'Y' && (extensionInvoiceCheck ?? "") == 'Y'


  const [showDoGeneratedDialog, setShowDoGeneratedDialog] = useState(false);
  const closeDoGeneratedDialog = () => setShowDoGeneratedDialog(false);
  const openDoGeneratedDialog = () => setShowDoGeneratedDialog(true);
  const [doGeneratedAMS, setDoGeneratedAMS] = useState<'Y' | 'N'>('N');

  const updateIsProcessing = (async (payload: any) => {
    dispatch(updateIsProcessingFlag(payload))
      .unwrap()
      .then((response) => {
        console.log('Processing flag updated successfully', response);
        // toast.success('Marked as Processing successfully!');
      })
      .catch((error) => {
        console.error('Failed to update processing flag', error);
        // toast.error('Failed to mark as Processing');
      });

  });



  const blidDocHistory: any = useSelector(
    (state: RootState) => state.documentHistory.data?.[0]?.blId
  );
  const instructionDashboardList = useSelector(
    (state: RootState) => state.dashboard.instructionDashboardList
  );
  // const [doExtension, setDoExtension] = useState<any>('N');
  const doExtension = watch('doExtension');
  const [approvalLevelsOptions, setApprovalLevelsOptions] = useState<{
    label: string,
    value: number
  }[]>([]);
  const decrptdoc = AESDecrypt(encryptdoc);
  const dataObl = useSelector((state: RootState) => state.instructionSlice.dataObl)
  const dashboardListArray = Array.isArray(instructionDashboardList)
    ? instructionDashboardList
    : Array.isArray(instructionDashboardList?.result)
      ? instructionDashboardList.result
      : [];
  const matchingInstruction = dashboardListArray.find((item: any) => item.bl_id === AESDecrypt(blNum));

  //  const displayNumber = dataObl?.number || matchingInstruction?.bl_no || '';
  const displayNumber = blNumDisplay ? blNumDisplay : oblNumber ? oblNumber : '';
  const decrptins = AESDecrypt(encrypt);
  const docId = decrptins;
  const onBack = useBackNavigation();
  const selectedPort = useSelector((state: RootState) => state.userProfile.selectedPort);


  const today = new Date();

  //Scroll object
  const rowColumns = useSelector(
    (state: RootState) => state.instructionTable.rowColumns
  );
  // to get pod value
  const oblForm = useSelector((state: RootState) => state.oblDetails.oblForm);
  const oblContainerList = useSelector(
    (state: RootState) => state.oblDetails.data?.list ?? []
  );

  //all instruction List
  const instructionList = useSelector(
    (state: RootState) => state.documentHistory.data
  );

  const linerDocs = useSelector((state: RootState) => state.demurrage.linerDocs)
  const receiptDocList = useSelector((state: RootState) => state.demurrage.receiptDocList);
  const receiptDocListLoading = useSelector((state: RootState) => state.demurrage.receiptDocListLoading);
  console.log(linerDocs,'<<linerDocs');
  
  //Non released Bl container Data
  const data = useSelector((state: RootState) => state.demurrage.data);

  /*   const dataCountry = useSelector(
    (state: RootState) => state.userProfile.linerDataCountry
  ); */
  const linerDataCountry = useSelector(
    (state: RootState) => state.userProfile.linerDataCountry
  );
  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );
  const dataCountry = useDataCountry();
  //By default attachment data
  //TODO: make dynamic
  const docAttachment = useSelector(
    (state: RootState) => state.demurrage.attData
  );
  const [is305Mandate, setIs305Mandate] = useState(false)
  const extensionAttData = useSelector(
    (state: RootState) => state.demurrage.extensionAttData
  );

  useConsole("ATTACHMENTS ", extensionAttData, docAttachment)

  // const [country, setCountry] = useState<any>(null);
  const serverFilePath = useSelector(
    (state: RootState) => state.demurrage.selectedFileServerPath
  );
  
  const isDirty = useSelector((state: RootState) => state.formDirty.isDirty);
  const docList = useSelector((state: RootState) => state.demurrage.docList);
  const extensionDocList = useSelector((state: RootState) => state.demurrage.extensionDocList);

  const dropdownDocList = useSelector((state: RootState) => state.demurrage.dropdownDocList);
  const currentDocList = doExtension == 'Y' ? extensionDocList ?? [] : docList ?? [];

  const csfList = useSelector((state: RootState) => state.demurrageViewSlice.cfsList);
  const emptyYardList = useSelector((state: RootState) => state.demurrageViewSlice.emptyYardList);

  //Pickup location dropdown list
  const pickUpLocation = useSelector(
    (state: RootState) => state.demurrage.pickUpLocation
  );

  //Saved container Pickup data
  const dataList = useSelector((state: RootState) => state.demurrageView.data);

  //Session user email id
  const userEmail = useSelector(
    (state: RootState) => state.userProfile.profile.email
  );
  const selectedLinerId = useSelector(
    (state: RootState) => state.navbarTop.linerId
  );

  //variable to save new Trucker Code Input values in table
  const [truckerCodearray, settruckerCodearray] = useState<any>([]);

  const [isDraft, setIsDraft] = useState(false)

  //variable to save new pickup date Input values in table
  const selectedDate = useSelector(
    (state: RootState) => state.demurrage.selectedDate
  );

  //variable to save new match code Input values in table
  const selectedinternalCode = useSelector(
    (state: RootState) => state.demurrage.selectedinternalCode
  );

  //variable to save new attachmentName Input values in table
  const selectedAttachmentName = useSelector(
    (state: RootState) => state.demurrage.selectedAttachmentName
  );

  const selectedDefaultPickupLocation = useSelector(
    (state: RootState) => state.demurrage.selectedDefaultPickupLocation
  );

  //variable to save new Attachemnt File path Input values in table
  const selectedAttachmentFilePath = useSelector(
    (state: RootState) => state.demurrage.selectedAttachmentFilePath
  );

  //variable to get attachment list

  const docVerifyFileName = useSelector(
    (state: RootState) => state.demurrage.attData.list
  );

  const checkListData = useSelector((state: RootState) => state.demurrage.checkList);
  const emptyYard = useSelector((state: RootState) =>
    (state.demurrage?.data?.list || []).find((x) => x.emptyYardPartnerId)?.emptyYardPartnerId
  );


  //variable to save new pickup location Input values in table
  const selectedPickupLocation = useSelector(
    (state: RootState) => state.demurrage.selectedPickupLocation
  );

  const selectedCfsName = useSelector(
    (state: RootState) => state.demurrage.selectedCfsName
  )

  const selectedCfsName216 = useSelector(
    (state: RootState) => state.demurrage.selectedCfsName216
  )

  const selectedEmptyYardName = useSelector(
    (state: RootState) => state.demurrage.selectedemptyYardName
  )



  //variable to save new Trucker name Input values in table
  const selectedTruckerName = useSelector(
    (state: RootState) => state.demurrage.selectedTruckerName
  );

  //variable to save new Trucker code Input values in table
  const selectedTruckerCode = useSelector(
    (state: RootState) => state.demurrage.selectedTruckerCode
  );

  //variable to save new Trucker id Input values in table
  const selectedtruckerId = useSelector(
    (state: RootState) => state.demurrage.selectedtruckerId
  );

  //variable to save new Attachemnt File in byte array Input values in table
  const selectedAttachmentBytrr = useSelector(
    (state: RootState) => state.demurrage.selectedAttachmentBytrr
  );

  //variable to save new Attachemnt File name Input values in table
  const selectedDocId = useSelector(
    (state: RootState) => state.demurrage.selectedDocId
  );

  const releasePOPData = useSelector((state: RootState) => state.invoiceUnpaid.releasePOPData)



  const impHaulage = useSelector(
    (state: RootState) => state.oblDetails.oblForm.haulage
  );

  //Release type drop down list
  const releaseTypeList = useSelector(
    (state: RootState) => state.invoiceChange.releaseTypeList
  );

  //Release Type value
  const [releaseType, setReleaseType] = useState(releaseTypeList[0]?.value);

  //getpickUp location from bl Type value
  //const defoultPickUplocation = useState(getPickuLocation[0]?.pickupLocation);

  //Session

  const demurrageForm = useSelector(
    (state: RootState) => state.demurrageViewSlice.demurrageForm
  );

  const linerId = useSelector((state: RootState) => state.navbarTop.linerId);
  const demurrageViewForm = useSelector(
    (state: RootState) => state.demurrageViewSlice.demurrageForm
  );

  //console.log(demurrageViewForm.dndInstructionId,"demurrageViewForm");


  const docVerifyEmailId = docVerifyFileName.map((i) => i.actionBy)

  const blEventId_docHistory: any = useSelector(
    (state: RootState) => state.documentHistory.data?.[0]?.blEventId
  );
  const blEventId_docInsDashboard: any = useSelector(
    (state: any) => state.dashboard.instructionDashboardList.result.filter((Item: any) => Item.bl_id == AESDecrypt(blNum))[0]?.bl_event_id
  );

  console.log(AESDecrypt(blNum),"ooo");
  const deleveryLocationList = useSelector(
    (state: RootState) => state.overstay.deleveryTypeLocation
  );
  const handleInvoiceModalYes = () => {
    // Gather all the form data you want to persist
    const formData = {
      senderEmail,
      requestedPartnerName,
      releaseType,
      userRemarks,
      doUploadStatus,
      doIntegrationRemarks,
      remarks,
      selectedDate,
      selectedPickupLocation,
      selectedTruckerName,
      selectedTruckerCode,
      selectedtruckerId,
      selectedinternalCode,
      selectedAttachmentName,
      selectedAttachmentFilePath,
      selectedNeedExtensionFor

    };


    localStorage.setItem('overstayExtensionFormData', JSON.stringify(formData));
    if (!blNum) {
      console.error("Cannot navigate because B/L Number is missing from the URL.");

      return;
    }

    const safeBlNum = encodeURIComponent(blNum);
    const safeDocId = encodeURIComponent(AESEncrypt('816'));
    dispatch(updateNavigateFlag(true))
    navigate(`${APP_PATH_PREFIX}/bl/${safeBlNum}/instruction/${safeDocId}`);


  };
  const form = document.querySelector<HTMLFormElement>('form');
  const handleInvoiceModalNo = () => {
    dispatch(updateNavigateFlag(false))
    if (doExtensionSoftStopConfig.toLowerCase() == 'no')
      onBack()
    else
      onSubmit()
    setShowDemurrgaeOrDeliveryModal(false)
  }

  const handleCopyBL = async (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event from bubbling up
    try {

      if (dataObl) {
        await navigator.clipboard.writeText(displayNumber || '');;
        //  toast.success(t('resource_2:copiedToClipboard') as string);
      } else {
        toast.error(t('resource_2:copyFailed') as string);
      }
    } catch (error) {
      console.error('Copy failed:', error);
      toast.error(t('resource_2:copyFailed') as string);
    }
  };


  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
  const matchPth = [
    {
      path: `${APP_PATH_PREFIX}/bl/:blNum/:encrypt/:encryptdoc`,
      condition: getUnprefixedPathname().split('/')[3] !== 'instruction',
    },
    {
      path: `${APP_PATH_PREFIX}/instruction/bl/:blNum/:encrypt/:encryptdoc`,
      condition: getUnprefixedPathname().split('/')[4] !== 'instruction',
    },
    {
      path: `${APP_PATH_PREFIX}/payment/bl/:blNum/:encrypt/:encryptdoc`,
      condition: getUnprefixedPathname().split('/')[4] !== 'instruction',
    },
    { path: `${APP_PATH_PREFIX}/instruction/:blNum/:encrypt/:encryptdoc` },
  ].some(({ path, condition }: { path: string; condition?: boolean }) => {
    return (
      (condition ?? true) &&
      matchPath({ path, caseSensitive: true, end: true }, location.pathname)
    );
  });

  const [blCountry, setBlCountry] = useBlCountry(
    matchPth ? "view" : "new",
    "import",
    804
  );


  const linerConfig=useLinerConfig(blCountry,linerId,804);
  const autoPopulateReceiptOnDO = linerConfig?.autoPopulateReceiptOnDO === 'Y';
  const autoPopulateReceiptDocId = Number(linerConfig?.autoPopulateReceiptDocId) || null;
  const isReceiptAutoPopulated =
    autoPopulateReceiptOnDO &&
    !!autoPopulateReceiptDocId &&
    !receiptDocListLoading &&
    !!receiptDocList?.length;

  const [disableFields, setDisableFields] = useState<any>(
    profileDetails?.partnerType === 'liner' ||
    (!!matchPth && profileDetails?.partnerType !== 'liner')
  );

  const isSarsDoHardStopEnabled =
    linerConfig?.sarsDoHardStop === 'Y';

  // const hasAnyContainerNotReleased =
  //   oblContainerList?.some(
  //     (row: any) => (row?.customsReleaseStatus ?? '') === 'NOT RELEASED'
  //   );
  const hasAnyContainerNotReleased =
    oblContainerList?.some((row: any) => {
      const status = row?.customsReleaseStatus;
      return status === '' || status === null || status === undefined || status === 'NOT RELEASED';
    });

  const isSarsCustomsReleaseBlocked = isSarsDoHardStopEnabled && hasAnyContainerNotReleased;

  const hasExplicitNotReleased = oblContainerList?.some(
    (row: any) => row?.customsReleaseStatus === 'NOT RELEASED'
  );

  const hasAnyEmptyStatus = oblContainerList?.some((row: any) => {
    const status = row?.customsReleaseStatus;
    return status === '' || status === null || status === undefined;
  });

  useEffect(() => {
    if (!isSarsDoHardStopEnabled) return;

    if (hasExplicitNotReleased) {
      toast.error(
        'The Delivery Order cannot be initiated as the Customs Release Status is Not Released'
      );
    } else if (hasAnyEmptyStatus) {
      toast.error(
        'The Delivery Order cannot be initiated as the Customs Release Status is Yet to Release'
      );
    }
  }, [isSarsDoHardStopEnabled, hasExplicitNotReleased, hasAnyEmptyStatus]);

  // useEffect(() => {
  //   if (hasAnyContainerNotReleased && isSarsDoHardStopEnabled) {
  //     toast.error(
  //       'The Delivery Order cannot be initiated as the Customs Release Status is Not Released'
  //     );
  //   }
  // }, [isSarsDoHardStopEnabled, hasAnyContainerNotReleased]);

  useEffect(() => {
    if (!disableFields && blNum && linerId && data.list) {
      dispatch(getLastestExtensionRequest({ 'blId': AESDecrypt(blNum), 'linerId': linerId }))
        .then((response: any) => {

          if (response?.payload?.data?.statusCode !== 400) {
            setShowDemurrgaeOrDeliveryModal(false);
          } else {
            setShowDemurrgaeOrDeliveryModal(true);
          }

          const containerList = response?.payload?.data?.containerDetails?.map((e: any) => ({
            containerNo: e?.cntNo,
            needExtensionFor: e?.pickupLocation,
            pickupDate: e?.pickupDate,
          })) || [];

          if (containerList.length > 0) {
            /* dispatch(updateDemurrageList({
              list: containerList,
              next: null,
              previous: null,
            })); */

            // Build the full mapping for all containers
            const needExtensionForMap: { [key: string]: string } = {};

            if (!recentId && !demurrageViewForm?.dndInstructionId) {
              const body = containerList.filter((container: any) => container.pickupDate.trim() != "")
                .reduce((b: any, a: any) => ({ ...b, [a.containerNo]: new Date(a.pickupDate) }), selectedDate)
              dispatch(updateSelectedDateDV(body))

              setSelectedNeedExtensionFor(needExtensionForMap);
            }
          }
        });
    } else {
      setShowDemurrgaeOrDeliveryModal(false);
    }
  }, [linerId, dataCountry, blNum, dispatch, disableFields, data.list.length]);

  useEffect(() => {
    if (linerId && dataCountry) {
      dispatch(getRequestInstructionConfigByType({
        'linerId': linerId,
        'country': dataCountry,
        "location": '',
        "currency": '',
        "requestType": "instruction",
        "requestIdentifier": "804"
      })).then((response: any) => {
        console.log("TESTTT",response)
        const configJsonString = response.payload.data[0]?.configJson;

        // Parse configJson
        if (configJsonString) {
          try {
            const config = JSON.parse(configJsonString);
            setDoExtensionConfig(config.doExtensionRequestAllowed);
            setDoExtensonCheckBoxShow(config.doExtensionRequestCheckBoxShow);
            setDoGeneratedAmsConfig(config.doGeneratedAms)
            setExtensionInvoiceCheck(config.extensionInvoiceCheck)
            setShowUnstuffingTypeConfig(config.showUnstuffingType)
            setCfsOrEmptyYardByLocationConfig(config.cfsOrEmptyYardByLocation)
            if(config.showPickupLocationFields)
            { 
              const showFields=config.showPickupLocationFields==='Yes';
              dispatch(clearPickupLocation());
              setShowPickupLocationFields(showFields)
            }
          } catch (e) {
            setDoExtensionConfig('No');
            setDoExtensonCheckBoxShow('No');
            setDoGeneratedAmsConfig('N')
            setExtensionInvoiceCheck('N')
            setShowUnstuffingTypeConfig('No')
            setCfsOrEmptyYardByLocationConfig('No')

            // if (linerId == '24118' && dataCountry == 'TZ') {
            //   setDoUploadStatusShow('No');
            // }
          }
        }
      });
    }
  }, [linerId, dataCountry]); // Only depend on linerId and dataCountry


  function checkPickupLocationValidity(
    containerArray: any[],
    selectedPickupLocationValue: { [s: string]: unknown },
    selectedTruckerName: { [s: string]: unknown },
    selectedDate: { [s: string]: null | string }
  ) {
    if(!showPickupLocationFields){
      return !!(Object.values(selectedDate)?.filter(n=>n).length > 0)
    }

    // no entries
    if (Object.values(selectedPickupLocationValue).findIndex(n => n && n !== '0') == -1) return false
    
    // overstay
    const overstay = Object.entries(selectedPickupLocationValue).filter(([k, v]) => v == '1002' && k !== 'location')
    if (overstay.length > 0) {
      if (overstay.findIndex(([k, v]) => selectedDate?.[k]) == -1) return false
    }

    // terminal
    const terminal = Object.entries(selectedPickupLocationValue).filter(([k, v]) => v == '1001' && k !== 'location')
    if (terminal.length > 0) {
      if (impHaulage !== 'Carrier Haulage' ||
        !['ZA', 'AO', 'GB', 'CM', 'UG', 'KE', 'TG','CI', 'CD', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ', 'LK','AE'].includes(blCountry)) {
        if (terminal.findIndex(([k, v]) => selectedTruckerName?.[k]) == -1) return false
      }
    }


    // Blank
    const blank = Object.entries(selectedPickupLocationValue).filter(([k, v]) => ((!v) || v == '0') && k !== 'location')
    if (blank.length > 0) {
      if (blank.findIndex(([k, v]) => selectedTruckerName?.[k] || selectedDate?.[k]) != -1) return false
    }

    return true
  }

  const PickupLocationValidityFlag = checkPickupLocationValidity(
    data.list,
    selectedPickupLocation,
    selectedTruckerName,
    selectedDate
  );

  const handleFileChange = (e: any, fileDocId: any, filePaths: any) => {
    if (e.target.files) {
      const file = e.target.files[0];
      if (file.size > attachedFileSize) {
        toast.error(
          `File size is greater than ${(+attachedFileSize) / 1000000}MB. Please upload file below ${(+attachedFileSize) / 1000000}MB`
        );
        e.target.value = null;
        return;
      }

      if (file.name.length > 70) {
        toast.error(t("resource_message:fileNameLimit60").toString());
        e.target.value = ""
        return
      }

      let fileExt = file.name.slice(-4);

      if (fileExt.toLowerCase() != '.pdf') {
        toast.error('Please upload Only PDF File');
        e.target.value = null;
        return;
      }
      const formData = new FormData();
      formData.append('file', file);
      try {
        // delete any existing file
        //if(filePaths[fileDocId]!==undefined){
        //  axiosInstance.post('deleteURL', filePaths[fileDocId])}

        // add file to bucket
        setLoadingFileState((state: any) => {
          return { ...state, [fileDocId]: 0 };
        });
        axiosInstance
          .post('/api/edo-rest-v1/v1/view/file', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            onUploadProgress(progressEvent) {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / (progressEvent.total ?? 1)
              );
              setLoadingFileState((state: any) => {
                return { ...state, [fileDocId]: percentCompleted };
              });
            },
          })
          .then((response) => {

          })
          .catch(() => {
            setLoadingFileState((state: any) => {
              return { ...state, [fileDocId]: -1 };
            });
          });

        // add server path to redux
      } catch (error) {
        console.error('File Upload Error: ', error);
        console.error('File Upload Error: ', error);
      }

      dispatch(
        updateSelectedAttachmentName({
          ...selectedAttachmentName,
          [fileDocId]: file,
        })
      );
      dispatch(
        updateSelectedAttachmentFilePath({
          ...selectedAttachmentFilePath,
          [fileDocId]: null,
        })
      );

      dispatch(
        updateSelectedDocId({
          ...selectedDocId,
          [fileDocId]: file[0],
        })
      );
    }
  };

  useEffect(() => {
    dispatch(getAppConfig('attachment.maxsize'))
      .unwrap()
      .then((response: any) => {
        if (response !== '') {
          setAttachedFileSize(+response.response.data);
        }
      });
  }, []);

  var has305 = true&& !!currentDocList.find(d=>d.id == 305)

  useEffect(() => {
    const mandatePopForUnpaidInvoice = linerConfig?.mandatePopForUnpaidInvoice == "Y";
    const isExtension = doExtension == 'Y';
    const selectedBlId = AESDecrypt(blNum) ?? demurrageForm.blId ?? blidDocHistory;

    if (currentDocList?.length && mandatePopForUnpaidInvoice && selectedBlId && has305) {
      dispatch(
        checkUnpaidInvoices({
          blid: selectedBlId,
          country: blCountry,
          linerId: linerId,
          location: null
        })
      )
        .unwrap()
        .then((paid) => {
          setIs305Mandate(!paid)
          // dispatch(updateDocumentMandatoryByDocId({ docId: 305, mandatory: !paid, isExtension }));
        });
    }


  }, [
    currentDocList?.length,
    linerConfig?.mandatePopForUnpaidInvoice,
    doExtension,
    blNum,
    demurrageForm.blId,
    blidDocHistory,
    blCountry,
    linerId,
    has305
  ]);

  useEffect(() => {
    if (selectedCfsName?.label === 'TEAGTL' && profileDetails.partnerType === 'liner') {
      setShowDoUploadStatus(true);
    } else {
      setShowDoUploadStatus(false);
    }
  }, [selectedCfsName]);

  useEffect(() => {
    setcurrStatus(demurrageForm?.status);
  }, [demurrageForm]);

  useEffect(() => {
    if (getUnprefixedPathname().split('/')[3] === 'instruction' || getUnprefixedPathname().split('/')[4] === 'instruction') {
      dispatch(
        getDefoultPickuLocation({
          blId: AESDecrypt(blNum),
          selectedLinerId:
            profileDetails.partnerType === 'liner'
              ? profileDetails.partnerId
              : selectedLinerId,
        })
      );
    }
    dispatch(
      getDemurrage({
        docId: AESDecrypt(blNum),
        location: getUnprefixedPathname().split('/')[3],
        selectedLinerId:
          profileDetails.partnerType === 'liner'
            ? profileDetails.partnerId
            : selectedLinerId,
        showPickupLocationFields: showPickupLocationFields
      })
    ).then()
  }, [blNum, selectedLinerId]);

  /* useEffect(() => {
    dispatch(getCheckList(1));

  },[]) */

  useEffect(() => {
    dispatch(resetDemurrageViewSlice(1));
    setIsCfsYardDisabled('');
    if (profileDetails.partnerType === 'liner') dispatch(clearPOPLInerData());
    // if (decrptdoc && docList && selectedLinerId) {
    if (decrptdoc && selectedLinerId) {
      dispatch(
        getDemurrageView({
          docId: decrptdoc,
          // docList: docList,
          country: blCountry,
          liner: selectedLinerId,
          // dropdownDocList: dropdownDocList,
          docAttachment: docAttachment?.list,
          selectedLinerId:
            profileDetails.partnerType === 'liner'
              ? profileDetails.partnerId
              : selectedLinerId,
        })
      )
        .unwrap()
        .then((v: any) => {
          //for view
          //show only current request container
          const containerList = v?.data?.list || v?.list || [];
          const selectedNeedExtensionForObj: { [containerNo: string]: string } = {};
          containerList.forEach((item: any) => {
            selectedNeedExtensionForObj[item.containerNo] = item.extensionFor || '';
          });

          setSelectedNeedExtensionFor(selectedNeedExtensionForObj);
          setIsProcessing(v?.data?.isProcessing ?? '');
          setIsCfsYardDisabled(v?.data?.doReceivedFromApi ?? '');
          setBlCountry(v?.data?.country)
          // setDoExtension(v?.data?.extFlag || 'N');
          setValue('doExtension', v?.data?.extFlag || 'N');
          setValue("doNumber", v?.data?.extensionDoNo)
          setBlNumDisplay(v?.data?.blNo)
          if (!v?.data?.blId) {
            onBack()
            toast.error('Please Try Again')
            return
          }
          if (v?.list?.length > 0) {
            dispatch(
              updateDemurrageList({
                list: data.list.filter((x: any) =>
                  v?.list
                    .map((y: any) => y?.containerNo)
                    .includes(x?.containerNo)
                ),
                next: null,
                previous: null,
              })
            );
          }

          setDndInstructionId(v?.data?.dndInstructionId);
          if (v?.data?.dndInstructionId) {
            setDisableFields(true);
            setIsEdit(false);
          }
          setValue('unstuffingType', v?.data?.unstuffing || '')
          setRemarks(v?.data?.remarks);
          setUserRemarks(v?.data?.userRemarks ?? '');
          setDoUploadStatus(v?.data?.doIntegrationStatus ?? '');
          setDoIntegrationRemarks(v?.data?.doIntegrationRemarks ?? '');
          if (v?.data?.attList.length > 0) {
            dispatch(updateAdttamentData(v?.data?.attList));
          }
        })
    }
  }, [decrptdoc, docId, location.pathname, !docList, selectedLinerId]);


  const dropdownDocId = (dropdownDocList ?? []).map((i: any) => i.id);

  const additionalDocCount = ((currentDocList?.filter((i: any) => (dropdownDocId.includes(i.id)))?.length ?? 0))


  const onApproveReject = (status: string, type: string) => {
    if (status && type) {

      if (status === 'A' &&
        accessGroupLevel.includes('Y') && checkListData?.some((i: any) => i.isMandatory == 'Y' && i.check == null && i.groupLevel == demurrageViewForm.groupLevel)) {
        toast.error('All Check list points need to be marked');
        return
      }

      if (!!linerDocs?.find?.((i) => !['100', 100, '0', 0, '-1', -1].includes(i.loading))) {
        toast.error('Can not approve request with ongoing upload')
        return
      }

      if (status == 'A') {
        const pendingFile = linerDocs?.filter((i) => i.m && !(disableEmptyYard && i.docId == 208) && (i.docId != 206 || !(linerDocs?.find(x=>x.docId == 216)?.fileName || linerDocs?.find(x=>x.docId == 216)?.serverPath)))
          ?.find((i) => (!i.serverPath || !i.fileName || i.loading != 100)
            && (i.doReleasePdfId == null && i.id == null))

        if (pendingFile) {
          toast.error(`Please Upload ${pendingFile.name
            } to Approve the request`)
          return
        }
        
        if (rbac.rbacDetails.cfsEmptyName == 'Y') {
          if ((!!linerDocs?.find((i) => i.docId == 206)?.fileName) !== (!!selectedCfsName.value)) {
            toast.error(`Please Add ${!!selectedCfsName.value ? linerDocs?.find((i) => i.docId == 206).name : 'CFS Name'
              } to Approve the request`)
            return
          } else if (!disableEmptyYard && (!!linerDocs?.find((i) => i.docId == 208)?.fileName) !== (!!selectedEmptyYardName.value)) {
            toast.error(`Please Add ${!!selectedEmptyYardName.value ? linerDocs?.find((i) => i.docId == 208).name : 'Empty Yard Name'
              } to Approve the request`)
            return
          } else if ((!!linerDocs?.find((i) => i.docId == 216)?.fileName) !== (!!selectedCfsName216.value)) {
            toast.error(`Please Add ${!!selectedCfsName216.value ? linerDocs?.find((i) => i.docId == 216).name : 'CFS Name'
              } to Approve the request`)
            return
          }
          const v206 = selectedCfsName?.value;
          const v216 = selectedCfsName216?.value;
          if (!!v206 && !!v216 && v206 != v216) {
            toast.error('CFS for SOC and Non SOC container must be the same.')
            return
          }
        }

      }

      if ((showUnstuffingTypeConfig ?? '').toLowerCase() === 'yes') {
        if (!watch('unstuffingType') || watch('unstuffingType') === '0') {
          setError('unstuffingType', {
            type: 'manual',
            message: 'Please select a valid Unstuffing Type',
          });
          return;
        }
      }

      const isShowUnstuffingType = ((showUnstuffingTypeConfig ?? '').toLowerCase() === 'yes')
    const unstuffingTypeValue = watch('unstuffingType')
const dndInstructionID= demurrageViewForm?.status != 'Submitted' && !demurrageViewForm?.status?.includes('Rejected')
              ? null
              : demurrageViewForm?.dndInstructionId || null
    

      if (status === 'R' && (remarks === '' || remarks == null)) {
        toast.dark(t('resource_message:remarksMandatory'));
      } else {
        dispatch(
          commonApproveReject({
            instructionId: dndInstructionId || null,
            blId: demurrageViewForm.blId,
            country: blCountry,
            instructionType: type || null,
            linerRemarks: remarks || null,
            customerRemarks: null,
            status: status || null,
            emailTo: demurrageViewForm.senderEmail || null,
            isVerify: !accessGroupLevel.includes('Y') || status === 'R' ? null : `${docAttachment.list.filter((item) => item.actionBy === profileDetails.email).map((item) => `${item.docId}-${item.isVerify}`)}`,
            requestType: 804,
            requestedPartnerId: profileDetails.partnerId,
            groupLevel: !accessGroupLevel.includes('Y') ? null : demurrageViewForm.groupLevel + 1,
            actionBy: !accessGroupLevel.includes('Y') ? null : profileDetails.email || null,
            checkList: checkListData?.filter(
              (i: any) => i.groupLevel == demurrageViewForm.groupLevel && i.check != null
            ).map((item: any) => ({
              codeId: item.docId,
              isVerify: item.check,
              remarks: item.remarks,
              docType: 8041,

            })),
            demurrageInstLinerAttDtls: linerDocs?.map((i) => ({
              demurrageInstructionLinerAttId: i.id,
              doReleasePdfId: i.doReleasePdfId,
              docId: i.docId,
              filePath: '',
              fileName: i.fileName,
              serverFilePath: i.serverPath,
              tempFileName: i.tempName,
              tempFilePath: i.filePath
            })),
            // actionOn:docVerifyUpdatedTime || null
            linerId: +selectedLinerId,
            cfsPartnerId: selectedCfsName.value
              ? +selectedCfsName.value
              : selectedCfsName216.value
                ? +selectedCfsName216.value
                : null,
            emptyYardPartnerId: disableEmptyYard ? null : (selectedEmptyYardName.value ? +selectedEmptyYardName.value : null),
            nextLevel: watch("selectedApprovalLevel") ? watch("selectedApprovalLevel") : null,
            unstuffing: (isShowUnstuffingType && unstuffingTypeValue) ? unstuffingTypeValue: '',
             version:version,
           })
        )
          .unwrap()
          .then((response: any) => {
            toast.success(response?.responseMsg);
            dispatch(updateDashbaordRefresh(true))
          })
          .catch((error: any) => {
            toast.error(error);
          });

        //update instruction list and redirect to previous page
        setTimeout(() => {
          dispatch(
            getInstructionList({
              blNum: AESDecrypt(blNum),
              country: profileDetails.partnerType == "liner" ? dataCountry : blCountry
            })
          );
        }, 3000);
        onBack();
      }
    }
  };
  const [senderEmail, setSenderEmail] = useState<any>(userEmail);
  const [dndInstructionId, setDndInstructionId] = useState('');
  const [tncUrl, setTncUrl] = useState<string | null>(null);
  const [remarks, setRemarks] = useState('');
  const [userRemarks, setUserRemarks] = useState('');
  const [doUploadStatus, setDoUploadStatus] = useState('');
  const [doIntegrationRemarks, setDoIntegrationRemarks] = useState('');


  const [requestedPartnerName, setRequestedPartnerName] = useState('');

  const rbac = useSelector((state: RootState) => state.userProfile);
  const loginPartnerId = useSelector((state: RootState) => state.userProfile?.profile?.partnerId);

  
console.log("dndInstructionId",demurrageViewForm?.dndInstructionId)

 
  const recentId = useSelector((state: RootState) => {
    const arr = state?.documentHistory?.data?.filter(
      (inst) =>
        inst.instructionId == 804 &&
        (inst.event == 'Submitted' || inst.event == 'Draft' || inst.event == 'Not Submitted')&& (inst.partnerId == null || inst.partnerId == loginPartnerId)
    );
    const recentInst = arr.length <= 0 ? null :
      arr.reduce((a: any, b: any) => (a.blEventId > b.blEventId ? a : b))

    return ['Y', '1', '2', '3', '4', '5', '6'].includes(recentInst?.docStatus ?? '')
      ? null
      : recentInst;
  });
  


  const recentCompletedId = useSelector((state: RootState) => {
    const arr = state?.documentHistory?.data?.filter(
      (inst) =>
        inst.instructionId == 804 &&
        (inst.event == 'Completed')
    );
    return arr.length <= 0 ? null :
      arr.reduce((a: any, b: any) => (a.blEventId > b.blEventId ? a : b))
  });


  const newEvent = useMemo(() => recentId?.docStatus?.trim() !== '', [])

  const reSubmit = useMemo(() => demurrageViewForm.status?.includes('Rejected')
    && demurrageViewForm.status != 'Rejected', [demurrageViewForm])


  const setInitialValue = () => {
    if (blNum) {
      const selectedDataDemurrage = dataList?.list?.find?.(
        (i: any) => i?.blId == AESDecrypt(blNum)
      );
      if (demurrageViewForm?.attList?.length > 0) {
        dispatch(updateAdttamentData(demurrageViewForm.attList));
      }
      if (selectedDataDemurrage) {
        setSenderEmail(selectedDataDemurrage?.senderEmail);
        setRemarks(selectedDataDemurrage?.remarks);

        setRequestedPartnerName(selectedDataDemurrage?.requestedPartnerName);
        setReleaseType(selectedDataDemurrage?.releaseType);
      }
    }
  };

  useEffect(() => {
    setLoadingFileState({})
    dispatch(clearFields())
    if (blCountry && selectedLinerId && !decrptdoc && !recentId) {
      dispatch(getReleaseAttConf({ country: blCountry, liner: selectedLinerId }))
    }

    let payload = null
    if ((!decrptdoc || decrptdoc?.length <= 0) && recentId?.docId && selectedLinerId) {
      payload = { id: recentId?.docId, selectedLinerId, country: blCountry, liner: selectedLinerId }
    } else if (!disableFields) {
      payload = { id: null, country: blCountry, liner: selectedLinerId }
    }

    if (payload && blCountry && selectedLinerId) {
      dispatch(getAttachmentsOnly(payload)).unwrap().then((data: any) => {
        setBlNumDisplay(data?.blNo)
        setValue('doExtension', data?.extFlag || 'N');
        setValue("doNumber", data?.extensionDoNo)
        setValue('unstuffingType', data?.unstuffing || '')
      })
    }

  }, [decrptdoc, recentId?.docId, selectedLinerId, blCountry]);

  useEffect(() => {
    if (!autoPopulateReceiptOnDO) {
      dispatch(clearReceiptDocList());
      return;
    }

    const selectedBlId = AESDecrypt(blNum);
    const linerIdForApi =
      profileDetails?.partnerType === 'liner'
        ? profileDetails?.partnerId
        : selectedLinerId;

    if (selectedBlId && linerIdForApi) {
      dispatch(
        getPaymentReceiptsForDO({
          blId: selectedBlId,
          selectedLinerId: linerIdForApi,
        })
      );
    }
  }, [
    autoPopulateReceiptOnDO,
    blNum,
    selectedLinerId,
    profileDetails?.partnerType,
    profileDetails?.partnerId,
  ]);

  useEffect(() => {

    if (doExtension !== 'Y') return;

    // if (decrptdoc && selectedLinerId) {
    //   dispatch(
    //     getDeliveryOrderDataForExtension({
    //       docId: decrptdoc, selectedLinerId:
    //         profileDetails.partnerType === 'liner'
    //           ? profileDetails.partnerId
    //           : selectedLinerId, country: blCountry, liner: selectedLinerId
    //     })
    //   )
    // }
    if (doExtension == 'Y' && blNum && selectedLinerId) {
      dispatch(
        getDeliveryOrderDataForExtension({ blId: AESDecrypt(blNum), selectedLinerId, country: blCountry, liner: selectedLinerId })
      ).unwrap().then((e: any) => {
        if (e?.extensionDoNo) {
          setIsSavedDoNumber(true)
          // setDoNumber(e?.data?.extensionDoNo)
          setValue('doNumber', e?.extensionDoNo)
        }

        const deliveryOrder = (e?.dndInstructionAtt ?? []).find((doc: any) => doc.docId === 206);
        if (deliveryOrder) {
          const docEntry = (extensionAttData?.list ?? []).find((doc: any) => doc.isDOExtensionFile)
          setLoadingFileState({ ...loadingFileState, [docEntry.rowNumber]: 100 })
        }
      });
    }
    // else if (!disableFields) {
    //   dispatch(getDeliveryOrderDataForExtension({ docId: null, country: blCountry, liner: selectedLinerId }));
    // }

  }, [decrptdoc, docId, blNum, location.pathname, selectedLinerId, doExtension, recentCompletedId?.docId]);



  useEffect(() => {
    dispatch(updateSelectedPickupLocation({}));
    dispatch(updateSelectedTruckerName({}));
    dispatch(updateSelectedtruckerId({}));
    dispatch(updateSelectedAttachmentName({}));
    setUserRemarks('');
    setDoUploadStatus('');
    setDoIntegrationRemarks('');
    setInitialValue();
  }, [docId]);

  useEffect(() => {
    if (blNum) {
      const selectedDataDemurrage = dataList?.list?.find?.(
        (i: any) => i?.blId == AESDecrypt(blNum)
      );
      if (selectedDataDemurrage) {
        //setSenderEmail()

        setSenderEmail(
          selectedDataDemurrage?.senderEmail
            ? selectedDataDemurrage?.senderEmail
            : senderEmail
        );
        setRemarks(selectedDataDemurrage?.remarks || '');
        setRequestedPartnerName(
          selectedDataDemurrage?.requestedPartnerName || ''
        );
        setReleaseType(selectedDataDemurrage?.releaseType || '');
      }
    }
  }, [dataList, blNum, location.pathname]);
  const _onReleaseTypeChange = useAsyncDebounce((value: string) => {
    setReleaseType(value);
  }, 200);
  const _onCloseForm = () => {

    if (decrptins == '804') {
      dispatch(toggleDocumentHistoryColumnShort(false));
    }
    if (location.pathname.includes('/bl')) {
      dispatch(
        updateBlDetailsRowColumns({
          ...rowColumns,
          mainTableClass: 'col-lg-2',
          documentMainViewClass: 'col-lg-10',
          documentHistoryClass: 'col-lg-12',
          outletClass: 'd-none',
        })
      );
    }
    setTimeout(() => {
      onBack();
    }, 500);
  };

  useEffect(() => {
    if (blNum && selectedLinerId && ['MY', 'MZ'].includes(blCountry) && (
      profileDetails.partnerType == "liner" || !location.pathname.includes("/bl/")))
      dispatch(
        getOBLDetails({
          blNumber: AESDecrypt(blNum) || null,
          selectedLinerId:
            profileDetails.partnerType === 'liner'
              ? profileDetails?.partnerId
              : selectedLinerId,
        })
      );
  }, [blNum, selectedLinerId, blCountry]);

  useEffect(() => {
    if (profileDetails?.partnerType == 'liner'
      && (blId || demurrageForm.blId || blidDocHistory)
      && (linerConfig.crrUnpaidHardStop == 'Y' || linerConfig.crrUnpaidSoftStop == 'Y')) {

      dispatch(getReleasePOPDetails({ blid: AESDecrypt(blNum) ?? demurrageForm.blId ?? blidDocHistory, country: blCountry }))
    }
  }, [profileDetails?.partnerType, blId, blidDocHistory, demurrageForm.blId, blCountry])

  useEffect(() => {
    // setLoadingFileState({})
    // dispatch(clearFields())
    // if (blCountry && selectedLinerId) {
    //   dispatch(getReleaseAttConf({ country: blCountry, liner: selectedLinerId }))
    // }
  }, [blCountry, selectedLinerId])

  type DoExtension = 'Y' | 'N';

  type FormValues = {
    senderEmail: string;
    value: string;
    pickupLocation: string;
    unstuffingType: string;
    requestedPartnerName: string;
    //destuffingType: string;
    releaseType: string;
    userRemarks: string;
    previousRejectionRemarks: string;
    selectedApprovalLevel: number;
    doUploadStatus: string;
    doNumber: string;
    doExtension: DoExtension;
    doIntegrationRemarks: string;
    // doGeneratedAMS: string;

  };

  const isFormDirty = () => {
    if (isDirty) return true;
    // Check if any file is present in selectedAttachmentName (handle both string and object with name property)
    if (
      selectedAttachmentName &&
      Object.values(selectedAttachmentName).some(val =>
        val && (typeof val === 'string' || (typeof val === 'object' && val !== null && 'name' in val && (val as { name?: string }).name))
      )
    ) {
      return true;
    }
    if (selectedAttachmentFilePath && Object.values(selectedAttachmentFilePath).some(val => val)) {
      return true;
    }
    return false;
  };

  const { showModal, handleNavigation, handleConfirm, handleCancel, handleBack } = useFormNavigationWarning({
    isChanged: isDirty,
    isEditable: true,
    onConfirm: onBack // or onBack, or your navigation function
  });

  const handleStayOnPage = () => {
    handleCancel();
  };

  const handleLeavePage = () => {
    onBack()
  };
  const [clearable, setClearable] = useState(true);

  const TableCell = (rowData: any) => {
    const { blContainerId, containerNo } = rowData.row.original;

    if (disableFields) {
      return (
        <span>
          {
            demurrageViewForm?.list?.find?.(
              (f: any) => f?.cntNo === containerNo
            )?.pickupDate
          }
        </span>
      );
    }
    return (
      <>
        <DatePicker
          selected={selectedDate?.[containerNo] || null}
          portalId='root-portal'
          onChange={(date) => {
            dispatch(
              updateSelectedDateDV({
                ...selectedDate,
                [containerNo]: date,
                intended: null,
              })
            );
          }}
          className='fs--2 form-control'
          timeIntervals={5}
          dateFormat={getDateFormat()}
          isClearable={clearable}
          popperProps={{
            strategy: 'fixed',
          }}
          disabled={
            selectedPickupLocation?.[containerNo] === '1001' && (!['KE', 'TG','CI', 'CM', 'TZ', 'MZ', 'CD', 'UG', 'BJ','LK','AE'].includes(blCountry) && (blCountry != 'ZA' || selectedLinerId == '1'))
          }
          minDate={new Date()}
        />
        {!data?.list
          ?.map((d) => (selectedDate?.[d.containerNo] ? true : false))
          .includes(true) &&
          !selectedDate?.[containerNo] && (
            <span className='text-danger f--1 mt-1'> </span>
          )}
      </>
    );
  };

  const [selectedContainerInput, setSelectedContainerInput] =
    useState<string>('');

  const TableCellTruckerId = (rowData: any) => {
    const { blContainerId, containerNo } = rowData.row.original;

    if (!disableFields) {
      return (
        <input
          type='text'
          className='fs--1 form-control'
          disabled={true}
          title={containerNo}
          defaultValue={selectedtruckerId?.[containerNo] || ''}
          onBlur={(e) => {
            e.preventDefault();

            dispatch(
              updateSelectedtruckerId({
                ...selectedtruckerId,
                [containerNo]: e.target.value,
              })
            );
          }}
        />
      );
    } else {
      return (
        <span>
          {
            demurrageViewForm?.list?.find?.(
              (f: any) => f?.cntNo === containerNo
            )?.truckerId
          }
        </span>
      );
    }
  };

  const TableCellInternalCode = (rowData: any) => {
    const { blContainerId, containerNo } = rowData.row.original;

    if (!disableFields) {
      return (
        <input
          type='text'
          className='fs--2 form-control'
          disabled={
            disableFields ||
            selectedPickupLocation?.[containerNo] === '1002' ||
            (impHaulage === 'Carrier Haulage' &&

              ['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CM', 'CD', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ','LK'].includes(blCountry))
          }
          // ref={inputRef}
          defaultValue={selectedinternalCode?.[containerNo] || ''}
          /*  ref={(input) => {
            if (input && selectedContainerInput === containerNo) {
              input.focus();
            }
          }} */
          /* onFocus={() => setSelectedContainerInput(containerNo)}
          onBlur={() => setSelectedContainerInput('')} */
          // value={inputCrn}
          onBlur={(e) => {
            e.preventDefault();
            // setInputCrn(e.target.value);

            dispatch(
              updateselectedInternalCode({
                ...selectedinternalCode,
                [containerNo]: e.target.value,
                // intended: date,
                //  truckerCode: null,
              })
            );
          }}
        />
      );
    } else {
      return (
        <span>
          {
            demurrageViewForm?.list?.find?.(
              (f: any) => f?.cntNo === containerNo
            )?.internalCode
          }
        </span>
      );
    }
  };

  const TableCellTrucker = (rowData: any) => {
    const { blContainerId, containerNo, cntStatus, truckerCode } =
      rowData.row.original;
    if (["ZZ"].includes(blCountry) && cntStatus === 'Completed') {
      return <span>{truckerCode}</span>;
    } else if (!disableFields) {
      return (
        <input
          type='text'
          className='fs--2 form-control'
          disabled={cntStatus == 'Completed' ? true : disableFields}
          title={containerNo}
          // ref={inputRef}
          defaultValue={selectedTruckerCode?.[containerNo] || ''}
          ref={(input) => {
            if (input && selectedContainerInput === containerNo) {
              input.focus();
            }
          }}
          onFocus={() => setSelectedContainerInput(containerNo)}
          onBlur={() => setSelectedContainerInput('')}
          // value={inputCrn}
          onChange={(e) => {
            e.preventDefault();
            // setInputCrn(e.target.value);

            dispatch(
              updateSelectedtruckerCode({
                ...selectedTruckerCode,
                [containerNo]: e.target.value,
                // intended: date,
                //  truckerCode: null,
              })
            );

            data?.list?.forEach((f: any) => {
              if (f.blContainerId === blContainerId) {
                const existingIndex = truckerCodearray.findIndex(
                  (item: any) => item.id === f.blContainerId
                );
                if (existingIndex !== -1) {
                  settruckerCodearray((prevArray: any) => {
                    const newArray = [...prevArray];
                    newArray[existingIndex] = {
                      value: e.target.value,
                      id: f.blContainerId,
                    };
                    return newArray;
                  });
                } else {
                  settruckerCodearray((prevArray: any) => [
                    ...prevArray,
                    { value: e.target.value, id: f.blContainerId },
                  ]);
                }
              }
            });
          }}
        />
      );
    } else {
      return (
        <span>
          {
            demurrageViewForm?.list?.find?.(
              (f: any) => f?.cntNo === containerNo
            )?.truckerCode
          }
        </span>
      );
    }
  };
  const locationOptions = (inputValue: string) =>
    new Promise<any[]>((resolve) => {
      setTimeout(() => {
        dispatch(getCFSNameList({ country: blCountry, name: inputValue }))
          .unwrap()
          .then((v: any) => {
            resolve(v);
          });
      }, 2000);
    });
  const TableCellReturnLocationExtension = (rowData: any) => {
    const { containerNo } = rowData.row.original;
    return (
      <Form.Select
        value={selectedNeedExtensionFor[containerNo] || ''}
        disabled={disableFields}
        onChange={e => {
          const value = e.target.value;
          setSelectedNeedExtensionFor((prev: { [key: string]: string }) => ({
            ...prev,
            [containerNo]: value
          }));
          dispatch(updateSelectedContainerNo({ containerNo, needExtensionFor: value }));
          dispatch(setDirty());
        }}
        className="fs--1 form-control form-select"
      >
        {extensionTypeOption.map(option => (
          <option key={option.value} value={String(option.value)}>
            {option.text}
          </option>
        ))}
      </Form.Select>
    );
  };

  const TableCellReturnLocation = (rowData: any) => {
    const { blContainerId, containerNo, } = rowData.row.original;

    if (!disableFields) {
      if (['KE', 'TG','CI', 'CM', 'TZ', 'MZ', 'CD', 'UG', 'BJ','LK'].includes(blCountry) || (blCountry == 'ZA' && selectedLinerId == '24118')) {
        return <div style={{ zIndex: 999 }}>
          <AsyncSelect
            menuPortalTarget={document.body}
            noOptionsMessage={({ inputValue }) => {
              return inputValue ? 'No options' : 'Type to search';
            }}
            classNames={{
              control: (state) => {
                return `dropControl fs--1 asyncDropField m-0 p-0
              form-control ${state.isDisabled ? 'disabledField' : ''}
              ${state.isFocused ? 'focusField' : ''}`;
              },
            }}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (base) => ({}),
            }}
            cacheOptions
            onChange={(e: any) => {
              dispatch(
                updateSelectedPickupLocation({
                  ...selectedPickupLocation,
                  [containerNo]: e?.cfsName ?? '',
                  location: null,
                })
              );
              if (!e?.cfsName) {
                dispatch(
                  updateSelectedTruckerName({
                    ...selectedTruckerName,
                    [containerNo]: null,
                    location: null,
                  })
                );
                dispatch(
                  updateSelectedtruckerId({
                    ...selectedtruckerId,
                    [containerNo]: null,
                    location: null,
                  })
                );
                dispatch(
                  updateselectedInternalCode({
                    ...selectedinternalCode,
                    [containerNo]: null,
                  })
                );
                dispatch(
                  updateSelectedDateDV({
                    ...selectedDate,
                    [containerNo]: null,
                  })
                );
              }
            }}
            value={{
              label: selectedPickupLocation?.[containerNo] || '',
              value: selectedPickupLocation?.[containerNo] || '',
            }}

            loadOptions={locationOptions}
            isDisabled={disableFields}
            isClearable={true}
          />
        </div>
      }
      return (
        <Form.Select
          disabled={disableFields}
          value={selectedPickupLocation?.[containerNo] || ''}
          onChange={(e) => {
            dispatch(
              updateSelectedPickupLocation({
                ...selectedPickupLocation,
                [containerNo]: e.target.value,
                location: null,
              })
            );
            dispatch(
              updateSelectedTruckerName({
                ...selectedTruckerName,
                [containerNo]: null,
                location: null,
              })
            );
            dispatch(
              updateSelectedtruckerId({
                ...selectedtruckerId,
                [containerNo]: null,
                location: null,
              })
            );
            dispatch(
              updateselectedInternalCode({
                ...selectedinternalCode,
                [containerNo]: null,
              })
            );
            dispatch(
              updateSelectedDateDV({
                ...selectedDate,
                [containerNo]: null,
              })
            );
          }}
          className='fs--1 form-control  form-select'>
          {
            <>
              {pickUpLocation.map((option: any) => (
                <option key={option.value} value={option.value}>
                  {option.text}
                </option>
              ))}
            </>
          }
        </Form.Select>
      );
    } else {
      return (
        <span>
          {
            ['KE', 'TG','CI', 'CM', 'TZ', 'MZ', 'CD', 'UG', 'BJ','LK'].includes(blCountry) || (blCountry == 'ZA' && selectedLinerId == '24118') ? demurrageViewForm?.list?.find?.(
              (f: any) => f?.cntNo === containerNo
            )?.pickupLocation
              :
              pickUpLocation.find(
                (v: any) =>
                  demurrageViewForm?.list?.find?.(
                    (f: any) => f?.cntNo === containerNo
                  )?.pickupLocation === v?.value.toString()
              )?.text
          }
        </span>
      );
    }
  };

  const version = useMemo(() => {
        const dndInstructionID= demurrageViewForm?.dndInstructionId || null;
              return ((!dndInstructionID && !demurrageViewForm?.version)?0:demurrageViewForm?.version) ?? null       
            }, [
              demurrageViewForm?.status,
              demurrageViewForm?.dndInstructionId,
              demurrageViewForm?.version
            ]);
            
  useEffect(() => {
    if (!currStatus) return;
    dispatch(fetchCFSNameByCountry({
      country: dataCountry,
      port: ((cfsOrEmptyYardByLocationConfig ?? '').toLowerCase() === 'yes') ? oblForm.importLocation : null,
      byLocation: (((cfsOrEmptyYardByLocationConfig ?? '').toLowerCase() === 'yes') && profileDetails.partnerType == 'liner')
    }))
    dispatch(fetchEmptyYardNameByCountry({
      country: dataCountry,
      port: ((cfsOrEmptyYardByLocationConfig ?? '').toLowerCase() === 'yes') ? oblForm.importLocation : null,
      byLocation: (((cfsOrEmptyYardByLocationConfig ?? '').toLowerCase() === 'yes') && profileDetails.partnerType == 'liner')
    }))
  }, [dataCountry, oblForm.exportLocation, currStatus, oblForm.importLocation, cfsOrEmptyYardByLocationConfig])

  useEffect(() => {
    if ((selectedCfsName?.value && !selectedCfsName?.label)) {

      const label = csfList.find((x) => x?.value == selectedCfsName?.value)?.text
      if (label) dispatch(
        updateSelectedCfsName({
          value: selectedCfsName?.value,
          label: label ?? null
        })
      );
    }
    if ((selectedCfsName216?.value && !selectedCfsName216?.label)) {
      const label216 = csfList.find((x) => x?.value == selectedCfsName216?.value)?.text
      if (label216) dispatch(
        updateSelectedCfsName216({
          value: selectedCfsName216?.value,
          label: label216 ?? null
        })
      );
    }
    if ((selectedEmptyYardName?.value && !selectedEmptyYardName?.label)) {
      const labelEmpty = emptyYardList.find((x) => x?.value == selectedEmptyYardName?.value)?.text

      if (labelEmpty) dispatch(
        updateSelectedemptyYardName({
          value: selectedEmptyYardName?.value,
          label: labelEmpty ?? null

        })

      );
    }

  }, [csfList, emptyYardList, selectedEmptyYardName, selectedCfsName, selectedCfsName216])

  const unstuffingTypeValue = watch('unstuffingType');
  const releaseInstructionConfig = getReleaseInstructionCountryConfig(blCountry, selectedLinerId);
  const disableEmptyYard = isEmptyYardDisabledByUnstuffing({
    unstuffingTypeValue,
    unstuffingTypeOptions,
    releaseInstructionConfig,
  });

  useEffect(() => {
    if (!disableEmptyYard || !selectedEmptyYardName?.value) return;
    if (demurrageForm.status == 'Completed' || demurrageForm.status?.includes('Rejected')) return;
    dispatch(updateSelectedemptyYardName({ label: null, value: null }));
  }, [disableEmptyYard, selectedEmptyYardName?.value, demurrageForm.status, dispatch]);

  const TableCellCfsList = (rowData: any) => {
    const { docId } = rowData.row.original;
    if (docId != 206 && docId != 208 && docId != 216 && docId != 218) return <></>
    const socLinerDoc = linerDocs?.find((i) => i.docId == 218);
    const socFileUploaded = !!(
      socLinerDoc?.fileName ||
      socLinerDoc?.filePath ||
      socLinerDoc?.serverPath ||
      socLinerDoc?.id
    );
    const liner206 = linerDocs?.find((i) => i.docId == 206);
    const has206LinerFile = !!(
      liner206?.fileName ||
      liner206?.filePath ||
      liner206?.id
    );
    const liner216 = linerDocs?.find((i) => i.docId == 216);
    const has216LinerFile = !!(
      liner216?.fileName ||
      liner216?.filePath ||
      liner216?.id
    );
    const emptyYardRow = emptyYardList.find((x) => x.value == selectedEmptyYardName.value)
    const cfs206Row = csfList.find((x) => x.value == selectedCfsName.value)
    const cfs216Row = csfList.find((x) => x.value == selectedCfsName216?.value)


    const isPilTz = blCountry == 'TZ' && selectedLinerId == '24118'
    const showCfsAsTextDisbaled = isPilTz && docId == 206 && !!selectedCfsName?.value && isCfsYardDisabled == 'Y'
    const showEmptyYardAsTextDisbaled = isPilTz && docId == 208 && !!selectedEmptyYardName?.value && isCfsYardDisabled == 'Y'



    if (instructionList.filter(
      (v: any) =>
        v?.docId === demurrageViewForm?.dndInstructionId
    ).sort((a: any, b: any) => +(b.blEventId ?? 0) - +(a.blEventId ?? 0))[0]?.event === 'Completed'
      || (demurrageForm.status == 'Completed' || demurrageForm.status?.includes('Rejected'))
      ||
      !(accessGroupLevel[demurrageViewForm.groupLevel] == 'Y' || !accessGroupLevel.includes('Y'))
      ||
      dataCountry !== blCountry || rbac.rbacDetails.demurrageApproveReject !== 'Y') {
      return <span>{
        docId == 218
          ? (socFileUploaded
            ? t('resource_2:noEmptyReturnSoc')
            : '')
          : docId == 208
            ? selectedEmptyYardName?.label ?? emptyYardRow?.text ?? ""
            : docId == 216
              ? (has216LinerFile
                ? selectedCfsName216?.label ?? cfs216Row?.text ?? ""
                : '')
              : docId == 206
                ? (has206LinerFile
                  ? selectedCfsName?.label ?? cfs206Row?.text ?? ""
                  : '')
                : ''
      } </span>
    }

    if (docId == 218) {
      return (
        <Form.Control
          type="text"
          disabled={true}
          className="fs--1"
          style={{ fontSize: '12px' }}
          value={socFileUploaded ? t('resource_2:noEmptyReturnSoc') : ''}
        />
      );
    }

    if (showCfsAsTextDisbaled) {
      return (
        <Form.Control
          type="text"
          disabled={true}
          className="fs--1"
          style={{ fontSize: '12px' }}
          value={selectedCfsName?.label ?? ''}
        />
      );
    }

    if (showEmptyYardAsTextDisbaled) {
      return (
        <Form.Control
          type="text"
          disabled={true}
          className="fs--1"
          style={{ fontSize: '12px' }}
          value={selectedEmptyYardName?.label ?? ''}
        />
      );
    }

    return <div style={{ zIndex: 999 }}>
      <Select
        menuPortalTarget={document.body}
        placeholder={docId == 206 || docId == 216 ? "CFS Name" : "Empty Yard Name "}
        options={(docId == 206 || docId == 216) ? csfList?.map(x => ({ label: x?.text, value: x?.value })) : emptyYardList?.map(x => ({ label: x?.text, value: x?.value }))}
        value={docId == 206 ? selectedCfsName : docId == 216 ? selectedCfsName216 : selectedEmptyYardName}
        classNames={{
          control: (state) => {
            return `dropControl asyncDropField m-0 p-0
              form-control ${state.isDisabled ? 'disabledField' : ''}
              ${state.isFocused ? 'focusField' : ''}`;
          },
        }}
        styles={{
          menuPortal: (base) => ({ ...base, fontSize: '12px', zIndex: 9999 }),
          control: (base) => ({ fontSize: '12px' }),
        }}

        onChange={(e: any) => {
          if (e == null) {
            e = {
              label: null,
              value: 0
            }
          }
          if (docId == 206) {
            dispatch(updateSelectedCfsName(e));
          } else if (docId == 216) {
            dispatch(updateSelectedCfsName216(e));
          } else {
            dispatch(updateSelectedemptyYardName(e));
          }

        }}

        isDisabled={
          (docId == 208 && disableEmptyYard)
          || instructionList.filter(
            (v: any) =>
              v?.docId === demurrageViewForm?.dndInstructionId
          ).sort((a: any, b: any) => +(b.blEventId ?? 0) - +(a.blEventId ?? 0))[0]?.event === 'Completed'
          || (demurrageForm.status == 'Completed' || demurrageForm.status?.includes('Rejected'))
          ||
          !(accessGroupLevel[demurrageViewForm.groupLevel] == 'Y' || !accessGroupLevel.includes('Y'))
          ||
          dataCountry !== blCountry || rbac.rbacDetails.demurrageApproveReject !== 'Y'
        }
        isClearable={true}
      />
    </div>


  };




  const promiseOptions = (inputValue: string) =>
    new Promise<any[]>((resolve) => {
      setTimeout(() => {
        dispatch(getTrukerNameList({ name: inputValue, country: blCountry,linerId:linerId }))
          .unwrap()
          .then((v: any) => {
            resolve(v);
          });
      }, 2000);
    });
  const TableCellTruckerName = (rowData: any) => {
    const { blContainerId, containerNo } = rowData.row.original;
    if (selectedTruckerName?.[containerNo]) {
      promiseOptions(selectedTruckerName?.[containerNo]);
    }

    if (!disableFields) {
      return (
        <div style={{ zIndex: 999 }}>
          <AsyncSelect
            menuPortalTarget={document.body}
            noOptionsMessage={({ inputValue }) => {
              return inputValue ? 'No options' : 'Type to search';
            }}
            classNames={{
              control: (state) => {
                return `dropControl fs--1 asyncDropField m-0 p-0
              form-control ${state.isDisabled ? 'disabledField' : ''}
              ${state.isFocused ? 'focusField' : ''}`;
              },
            }}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (base) => ({}),
            }}
            cacheOptions
            onChange={(e: any) => {
              dispatch(
                updateSelectedTruckerName({
                  ...selectedTruckerName,
                  [containerNo]: e?.truckerName,
                  location: null,
                })
              );
              dispatch(
                updateSelectedtruckerId({
                  ...selectedtruckerId,
                  [containerNo]: e?.truckerId,
                  location: null,
                })
              );
              dispatch(
                updateselectedInternalCode({
                  ...selectedinternalCode,
                  [containerNo]: e?.internalCode,
                })
              );
            }}
            value={{
              label: selectedTruckerName?.[containerNo] || '',
              value: selectedTruckerName?.[containerNo] || '',
            }}
            loadOptions={promiseOptions}
            isDisabled={
              selectedPickupLocation?.[containerNo] === '1002' ||
              (impHaulage === 'Carrier Haulage' &&
                ['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CM', 'CD', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ','LK'].includes(blCountry))
            }
            isClearable={true}
          />
        </div>

        /*  <Form.Select
          disabled={disableFields}
          value={selectedTruckerName?.[containerNo] || ''}
          autoComplete='n'
          onChange={(e) => {
            dispatch(
              updateSelectedTruckerName({
                ...selectedTruckerName,
                [containerNo]: e.target.value,
                location: null,
              })
            );
            /* setPayloadList(
              data?.list?.map((f: any) =>
                f.blContainerId === blContainerId
                  ? {
                      ...f,
                      returnLocation: e.target.value,
                    }
                  : f
              )
            );  
          }}
          className='fs--1 form-control  form-select'>
          {
            <>
              <option value=''>Select</option>
              <option value='Johannasbag'>Over stay Depot</option>
              <option value='Terminal'>Terminal</option>
            </>
          }
        </Form.Select>
        */
      );
    } else {
      return (
        <span>
          {
            demurrageViewForm?.list?.find?.(
              (f: any) => f?.cntNo === containerNo
            )?.truckerName
          }
        </span>
      );
    }
  };

  const accessGroupLevel = [rbac.rbacDetails.crrLevelOne, rbac.rbacDetails.crrLevelTwo, rbac.rbacDetails.crrLevelThree, rbac.rbacDetails.crrLevelFour, rbac.rbacDetails.crrLevelFive, rbac.rbacDetails.crrLevelSix, rbac.rbacDetails.crrLevelSeven, rbac.rbacDetails.crrLevelEight, rbac.rbacDetails.crrLevelNine, rbac.rbacDetails.crrLevelTen]
  const uploadDoument = (rowData: any) => {
    const { docId, dndInstructionAttId, fileName, actionBy, isVerify, rowNumber, isDropDownDoc, isDOExtensionFile } = rowData.row.original;
    // const key = dndInstructionAttId ?? (isDropDownDoc ? rowNumber ?? null : null);
    const key = dndInstructionAttId ?? rowNumber ?? null;
    const charLimit = (name: string, limit: number) =>
      name && name?.length >= limit ? name?.substring(0, limit) + '...' : name;
    if (!disableFields) {
      return (
        <div className='d-flex justify-content-start align-items-center'>
          <UploadThing
            name={selectedAttachmentFilePath?.[key]
              ? fileName
              : selectedAttachmentName?.[key]?.name
            }
            loading={loadingFileState[key]}
            disabled={!!isVerify || Object.values(loadingFileState).some(
              (val) => val != 100 && val != -1 && val != undefined
            ) || (isDOExtensionFile && dndInstructionAttId)}

            fulfilled={function (name: string, serverPath: string, serverName: string): void {
              setLoadingFileState((state: any) => {
                return { ...state, [key]: 100 };
              });
              dispatch(
                updateSelectedFileServerPath({
                  ...serverFilePath,
                  [key]: [serverPath, serverName],
                })
              );
              dispatch(
                updateSelectedAttachmentName({
                  ...selectedAttachmentName,
                  [key]: { name },
                })
              );
            }}

            failed={function (): void {
              setLoadingFileState((state: any) => {
                return { ...state, [key]: -1 };
              });
              dispatch(
                updateSelectedAttachmentName({
                  ...selectedAttachmentName,
                  [key]: { name: '' },
                })
              );
            }}

            pending={function (loading: number): void {
              setLoadingFileState((state: any) => {
                return { ...state, [key]: loading };
              });
            }}

            clear={() => {/* allowRemove is false */ }}

            selected={function (name: string): void {
              dispatch(
                updateSelectedAttachmentName({
                  ...selectedAttachmentName,
                  [key]: { name },
                })
              );
              setLoadingFileState((state: any) => {
                return { ...state, [key]: 0 };
              });
              dispatch(
                updateSelectedAttachmentFilePath({
                  ...selectedAttachmentFilePath,
                  [key]: null,
                })
              );
            }}
            fileLimit={10}
            fileType={['PDF']}
            labelWidth='250px'
            link={!selectedAttachmentFilePath?.[key] ? undefined : `${process.env.REACT_APP_CLIENT_APP_HOST
              }/api/edo-rest-v2/v2/common/openDocument?id=${encryptAndEncode(dndInstructionAttId)}&moduleTp=DND&linerId=${encryptAndEncode(profileDetails.partnerType === 'liner'
                ? profileDetails?.partnerId
                : selectedLinerId)
              }&rd=N`}
            allowRemove={false}
          />
          {/* <label
            className='btn btn-sm btn-falcon-primary m-0 me-2 '
            style={Object.values(loadingFileState).some(
              (val) => val != 100 && val != -1
          )?{cursor:'auto', opacity:'0.5'}:{}}
            htmlFor={`${docId}-input`}>
            <FontAwesomeIcon icon={faUpload} />
          </label>
          <input
            id={`${docId}-input`}
            title='Input'
            type='file'
            className='fs--2 form-control ms-1'
            disabled={disableFields || Object.values(loadingFileState).some(
              (val) => val != 100 && val != -1
          )}
            accept='.pdf'
            onClick={() => {
              updateSelectedFileServerPath({
                ...serverFilePath,
                [docId]: [null, null],
              });
            }}
            onChange={(e) => {
              handleFileChange(e, docId, serverFilePath);
            }}
            hidden
          />
          {selectedAttachmentFilePath?.[docId] ? (
            <span
              title={fileName}
              className='text-primary cursor-pointer'
              onClick={() => {
                window.open(
                  `${
                    process.env.REACT_APP_CLIENT_APP_HOST
                  }/api/edo-rest-v2/v2/common/openDocument?id=${encryptAndEncode(dndInstructionAttId)}&moduleTp=DND&linerId=${encryptAndEncode(
                    profileDetails.partnerType === 'liner'
                      ? profileDetails?.partnerId
                      : selectedLinerId)
                  }`,
                  '_blank'
                );
              }}>
              {charLimit(fileName, 45)}
            </span>
          ) : (
            <>
              <span title={selectedAttachmentName?.[docId]?.name}>
                {charLimit(selectedAttachmentName?.[docId]?.name, 45)}
              </span>
              {selectedAttachmentName?.[docId]?.name && (
                <UploadIndicator
                  style={{ marginLeft: '20px' }}
                  progress={loadingFileState[docId]}
                  fail={loadingFileState[docId] === -1}
                />
              )}
            </>
          )} */}
        </div>
      );
    } else {
      return (
        <div className='d-flex justify-content-start align-items-center'>
          {/*  <label
            className='btn btn-sm btn-dark m-0 me-2'
            htmlFor={`${docId}-input`}>
            Choose
          </label>
          <input
            id={`${docId}-input`}
            title='Input'
            type='file'
            className='fs--2 form-control ms-1'
            disabled={disableFields}
            onChange={(e) => {
              handleFileChange(e, docId);
            }}
            hidden
          /> */}

          <span
            className='text-primary cursor-pointer'
						onClick={async () => {
						  await openDocumentInNewTab({
						    url: '/api/edo-rest-v2/v2/common/openDocument',
						    params: {
						      id: encryptAndEncode(dndInstructionAttId),
						      moduleTp: 'DND',
						      linerId: encryptAndEncode(
						        profileDetails.partnerType === 'liner'
						          ? profileDetails?.partnerId
						          : selectedLinerId
						      ),
						    },
						  });
						}}>
            {charLimit(fileName, 50)}
          </span>
        </div>
      );
    }
  };


  const documentCheck = (rowData: any) => {
    const { docId, check, groupLevel } = rowData.row.original;

    return (
      <><span className="radio p-2">
        <label> Yes <input type="radio" name={docId} value="true" className='form-check-input'
          disabled={accessGroupLevel[groupLevel] != 'Y' || groupLevel != demurrageViewForm.groupLevel}
          checked={check == 'Y'} onChange={(e: ChangeEvent<HTMLInputElement>) => {
            dispatch(updateSelectedCheckList({
              check: 'Y',
              docId: docId,
            }))

          }} />
        </label>
      </span>
        <span className="radio p-2">
          <label> No <input type="radio" name={docId} value="false" className='form-check-input'
            disabled={accessGroupLevel[groupLevel] != 'Y' || groupLevel != demurrageViewForm.groupLevel}
            checked={check === 'N'} onChange={(e: ChangeEvent<HTMLInputElement>) => {
              dispatch(updateSelectedCheckList({
                check: 'N',
                docId: docId,
              }))

            }} /></label>
        </span>
      </>

    );

  };


  const TableVerifyDoc = (rowData: any) => {
    const { type, allowAccess, docId, isVerify, fileName, actionBy } = rowData.row.original;
    //const name = 'TableVerifyDoc' + type.toString();
    if (fileName) {
      return (
        <div className='d-flex justify-content-start align-items-center'>
          <input
            type='checkbox'
            onChange={(e: ChangeEvent<HTMLInputElement>) => {

              dispatch(updateLinerVerify({
                verify: e.target.checked,
                docId: docId,
                fileName: fileName,
                actionBy: (e.target.checked == (demurrageForm.attList.find((i) => i.docId == docId)?.isVerify)) ? demurrageForm.attList.find((i) => i.docId == docId).actionBy : profileDetails.email,
                actionOn: (e.target.checked == (demurrageForm.attList.find((i) => i.docId == docId)?.isVerify)) ? demurrageForm.attList.find((i) => i.docId == docId).actionOn : moment(
                  moment
                    .utc(new Date())
                    .toDate()
                ).format(getDateTimeFormat().toLocaleUpperCase())


              }))

            }

            }
            checked={isVerify}
            disabled={profileDetails.partnerType !== 'liner' || !(accessGroupLevel[demurrageViewForm.groupLevel] == 'Y') || (demurrageViewForm.status == 'Completed' || demurrageViewForm.status?.includes('Rejected'))}
          />
        </div>
      )
    }

  };

  const TableRemoveDoc = (rowData: any) => {
    const { type, allowAccess, docId, isVerify, fileName, actionBy, isDropDownDoc, rowNumber, dndInstructionAttId } = rowData.row.original;
    //const name = 'TableVerifyDoc' + type.toString();
    if (isDropDownDoc) {
      return (
        <div className='d-flex justify-content-start align-items-center'>
          {(!disableFields && !dndInstructionAttId) && (
            <div>
              <Button
                variant='falcon-warning'
                style={{ background: 'transparent', border: 'none', boxShadow: 'none', padding: '0px' }}
                onClick={(e: any) => {
                  // if (!dropdownDocList || dropdownDocList.length === 0) return;
                  dispatch(removeDocument({ rowNumber: rowNumber, isExtension: doExtension == 'Y' }));
                  const { [rowNumber]: removedLoadingState, ...restLoadingState } = loadingFileState ?? {};
                  const newLoadingFileState = Object.keys(restLoadingState).length > 0 ?
                    restLoadingState : {};
                  setLoadingFileState(newLoadingFileState)
                }}
                disabled={!isDropDownDoc || !!isVerify || Object.values(loadingFileState).some(
                  (val) => val != 100 && val != -1 && val != undefined
                ) || dndInstructionAttId}
              // disabled={docList?.length >= 10}
              //             disabled={profileDetails.partnerType !== 'liner' || !(accessGroupLevel[demurrageViewForm.groupLevel] == 'Y') || (demurrageViewForm.status == 'Completed' || demurrageViewForm.status?.includes('Rejected'))}
              >
                <FontAwesomeIcon className="me-1" icon={faTrash} />
              </Button>
            </div>
          )}
        </div>
      )
    }



  };

  const TableLinerId = (rowData: any) => {
    const { actionBy } = rowData.row.original;
    return (

      <div className='d-flex justify-content-start align-items-center'>
        <span> {actionBy}  </span>
      </div>

    );
  };

  const TableLastUpdated = (rowData: any) => {
    const { actionOn } = rowData.row.original;
    new Date()
    return (

      <div className='d-flex justify-content-start align-items-center'>
        <span>{actionOn}</span>
      </div>

    );
  };


  const TableCheckListRemark = (rowData: any) => {
    const { docId, remarks, groupLevel } = rowData.row.original;

    return (
      <input
        type='text'
        className='fs--2 form-control'
        disabled={accessGroupLevel[groupLevel] != 'Y' || groupLevel != demurrageViewForm.groupLevel}
        defaultValue={remarks}
        onBlur={(e) => {
          e.preventDefault();
          dispatch(
            updateselectedCheckListRemark({
              docId,
              remarks: e.target.value,

            })
          );
        }}
      />

    );

  };

  const TableCheckListDocName = (rowData: any) => {
    const { docId, name } = rowData.row.original;

    return (

      <span title={name}>{name}</span>


    );

  };

  const resetForm = () => {
    setSenderEmail('');
    dispatch(updateSelectedDateDV({ intended: null }));
    dispatch(updateSelectedtruckerCode({ truckerCode: '' }));
    dispatch(updateSelectedPickupLocation({}));
    dispatch(updateSelectedTruckerName({}));
    dispatch(updateSelectedtruckerId({}));
    // dispatch(updateSelectedAttachmentName({}));
    // dispatch(updateSelectedAttachmentFilePath({}));
    // dispatch(clearSelectedFileServerPath());
    setUserRemarks('');
    // setLoadingFileState({})
    // dispatch(clearFields())
    // if (blCountry && selectedLinerId) {
    //   dispatch(getReleaseAttConf({ country: blCountry, liner: selectedLinerId }))
    // }
    setValue("doNumber", "")
    setValue("unstuffingType", "0")

  };
  const language = useSelector((state: RootState) => state.navbarTop.language);
  const configKey = `${dataCountry}_${linerId}_${dndInstructionId}_${location}`;
  const fetchedRef = useRef<Record<string, boolean>>({});

  const config = useSelector(
    (state: RootState) => state.instructionSlice.linerConfig
  )?.[configKey];

console.log(version,"::version");

console.log("config",config)

/* useEffect(() => {
  const fetchTnC = async () => {
      try {
          const response = await dispatch(
              getTncConsent({
                  partnerId: linerId,
                  countryCode: dataCountry,
                   module: "CRR_GURANT",
                  language
              })
          ).unwrap();
        if(linerId && dataCountry){
          setTncUrl(response?.tncUrl ?? null);
        }
      } catch (error) {
          setTncUrl(null);
      }
  };

  if (linerId && dataCountry) {
      fetchTnC();
  }
 // console.log(linerId, dataCountry, "iiii");

}, [dataCountry,linerId,module,language]); */

useEffect(() => {
  //if (!dataCountry || !linerId) return;
  //if (config) return;
 // if (fetchedRef.current[configKey]) return;

  fetchedRef.current[configKey] = true;

  dispatch(
    getInstructionDocTemplates({
      linerId,
      country: dataCountry,
      location: location ? String(location) : '',
      instructionId:804,
      configKey
    })
  ).unwrap().then((data)=>{
    console.log("data",data);
    setTemplateList(data)

  });
}, [dataCountry, linerId,location, config, configKey]);

//return config ?? {};

  const onSubmit = handleSubmit(async (payload) => {
    //api 1 response empty means
    dispatch(updateNavigateFlag(false))
    if ((showUnstuffingTypeConfig ?? '').toLowerCase() === 'yes') {
      if (!watch('unstuffingType') || watch('unstuffingType') === '0') {
        setError('unstuffingType', {
          type: 'manual',
          message: 'Please select a valid Unstuffing Type',
        });
        return;
      }
    }
    setSubmitFlag(true);
    const idValueMap: { [id: string]: string } = {};
    truckerCodearray.forEach((item: { id: string | number; value: string }) => {
      idValueMap[item.id] = item.value;
    });

    const docAttachmentKey = doExtension == 'Y' ? extensionAttData : docAttachment;
    const viewFormAttKey = doExtension == 'Y' ? demurrageViewForm.extensionAttList : demurrageViewForm.attList;

    const isShowUnstuffingType = ((showUnstuffingTypeConfig ?? '').toLowerCase() === 'yes')
    const unstuffingTypeValue = watch('unstuffingType')
    const dndInstructionID= demurrageViewForm?.status != 'Submitted' && !demurrageViewForm?.status?.includes('Rejected')
              ? null
              : demurrageViewForm?.dndInstructionId || null
    try {
      await dispatch(
        addDemurrage({
          ...payload,
          unstuffing: (isShowUnstuffingType && unstuffingTypeValue) ? unstuffingTypeValue: '',
          requestedPartnerId: profileDetails?.partnerId,
          blId: AESDecrypt(blNum),
          country: blCountry,
          extFlag: doExtension === 'Y' ? 'Y' : null,
          dndInstructionId:dndInstructionID,
          senderEmail: senderEmail,
          remarks: (linerId != '24118' && instructionList
            .filter(
              (v: any) => v?.docId === demurrageViewForm?.dndInstructionId
            )
            .map((u: any) => u?.event?.includes('Rejected'))
            .includes(true))
            ? ''
            : demurrageViewForm?.remarks || '',
          userRemarks: userRemarks,
          status: isDraft ? "Draft" :
            demurrageViewForm.groupLevel ? `Approved by L${demurrageViewForm.groupLevel}` :
              "Submitted",
          list: data?.list
            ?.filter((v: any) =>
              ['SG', 'VN'].includes(blCountry)
                ? !(v.cntStatus === 'Completed') &&
                selectedTruckerCode?.[v.containerNo]
                : true
            )
            .map?.((d: any, index) => ({
              ...d,
              containerPickupId:
                demurrageViewForm?.list?.find(
                  (x: any) => d?.containerNo === x?.containerNo
                )?.containerPickupId || null,
              //  truckerCode: inputRef.current?.value,
              /*  truckerCode: updatedArray.find(
              (code) => code.id == d.blContainerId.toString()
            )?.value, */
              truckerCode: d?.containerNo
                ? selectedTruckerCode?.[d.containerNo]
                  ? selectedTruckerCode?.[d.containerNo]
                  : null
                : null,
              truckerId: d?.containerNo
                ? selectedtruckerId?.[d.containerNo]
                  ? selectedtruckerId?.[d.containerNo]
                  : null
                : null,

              internalCode: d?.containerNo
                ? selectedinternalCode?.[d.containerNo]
                  ? selectedinternalCode?.[d.containerNo]
                  : null
                : null,
              pickupLocation: d?.containerNo
                ? selectedPickupLocation?.[d.containerNo]
                  ? selectedPickupLocation?.[d.containerNo]
                  : null
                : null,

              extensionFor: d?.containerNo
                ? selectedNeedExtensionFor?.[d.containerNo]
                  ? selectedNeedExtensionFor[d.containerNo]
                  : null
                : null,
              truckerName: d?.containerNo
                ? selectedTruckerName?.[d.containerNo]
                  ? selectedTruckerName?.[d.containerNo]
                  : null
                : null,
              pickupDate: d?.containerNo
                ? selectedDate?.[d.containerNo]
                  ? moment(selectedDate?.[d.containerNo] + ' UTC')?.format(
                    'YYYY-MM-DD'
                  )
                  : null
                : null,
            })),
          extensionDoNo: payload.doNumber,
          docList: docAttachmentKey?.list?.filter((d) => loadingFileState[d.docId] != -1).map?.((d: any, index) => {
            const key = d?.dndInstructionAttId ?? d?.rowNumber ?? null;
            return {
              ...d,
              dndInstructionAttId: (demurrageViewForm.status == 'Submitted') ||
                (demurrageViewForm.status == 'Not Submitted') ||
                (demurrageViewForm.status == 'Draft') ?
                viewFormAttKey?.find(
                  (x: any) => d?.docId === x?.docId
                )?.dndInstructionAttId ?? null : null,
              docId: d?.docId,
              filePath: d?.docId ? selectedAttachmentFilePath?.[key] : null,
              fileName: d?.docId ? selectedAttachmentName?.[key]?.name : null,
              serverPath: d?.docId ? serverFilePath?.[key]?.[0] : null,
              tempFileName: d?.docId ? serverFilePath?.[key]?.[1] : null,
            }
          }),
          docId,
          checkList: checkListData,
          groupLevel: demurrageViewForm?.groupLevel ?? 0,
          linerId: +selectedLinerId,
          version:version,
        })
      );

    } catch (err: any) {
      console.error(err.message);
      console.error(err.message);
    }

    //dispatch(getInstructionList(AESDecrypt(blNum)));
    setTimeout(() => {
      dispatch(
        getInstructionList({
          blNum: AESDecrypt(blNum),
          country: profileDetails.partnerType == "liner" ? dataCountry : blCountry
        })
      );
      dispatch(updateDashbaordRefresh(true))
    }, 3500);

    onBack()

    setSubmitFlag(false);
    setIsEdit(false);
  }, (e) => { console.log("VALIDATION", e) });

  const contactDetailsColumns: IDataTableColumn[] = [
    {
      accessor: 'blContainerId',
      Header: 'blContainerId',
    },

    {
      accessor: 'containerNo',
      Header: t('resource_2:containerNo'),
      width: 200,
      maxWidth: 150,
    },

    // (['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CM', 'CD', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK'].includes(blCountry) && showPickupLocationFields)
    //   ? 
      {
        accessor: 'pickupLocation',
        Header: t('resource_2:pickupLocation'),
        width: ['KE', 'TG','CI', 'CD', 'UG', 'CM', 'TZ', 'MZ', 'MZ', 'BJ','LK'].includes(blCountry) || (blCountry == 'ZA' && selectedLinerId == '24118') ? 250 : 178,
        maxWidth: ['KE', 'TG','CI', 'CD', 'UG', 'CM', 'TZ', 'MZ', 'MZ', 'BJ','LK'].includes(blCountry) || (blCountry == 'ZA' && selectedLinerId == '24118') ? 250 : 178,
        Cell: TableCellReturnLocation,
      },
      // : {
      //   accessor: 'pickupLocation',
      //   Header: '',
      //   width: 0,
      //   maxWidth: 0,
      // },

    !['SG', 'VN'].includes(blCountry)
      ? {
        accessor: 'IntendedDate',
        Header: t('resource_2:IntendedDate'),
        width: 190,
        maxWidth: 190,
        Cell: TableCell,
        //  columnFilterType: 'date-range',
      }
      : {
        accessor: 'IntendedDate',
        Header: '',
        width: 0,
        maxWidth: 0,
      },
    // (blCountry == 'MZ' && doExtension === 'Y') ?
    //   {
    //     accessor: 'needExtensionFor',
    //     Header: t('resource_3:needExtensionFor'),
    //     width: 220,
    //     maxWidth: 220,
    //     Cell: TableCellReturnLocationExtension,
    //   } : { accessor: 'needExtensionFor', Header: '', width: 0, maxWidth: 0 },
    ['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CD', 'CM', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ','LK'].includes(blCountry)
      ? {
        accessor: 'truckerName',
        Header: t('resource_2:trukerName'),
        width: 170,
        maxWidth: 170,
        Cell: TableCellTruckerName,
      }
      : { accessor: 'truckerName', Header: '', width: 0, maxWidth: 0 },

    ['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CD', 'CM', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ','LK','AE'].includes(blCountry)
      ? {
        accessor: 'truckerId',
        Header: t('resource_2:trukerId'),
        width: 170,
        maxWidth: 170,
        Cell: TableCellTruckerId,
      }
      : { accessor: 'truckerId', Header: '', width: 0, maxWidth: 0 },

    ['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CD', 'CM', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ','LK','AE'].includes(blCountry)
      ? {
        accessor: 'internalCode',
        Header: t('resource_2:internalCode'),
        width: 170,
        maxWidth: 170,
        Cell: TableCellInternalCode,
      }
      : {
        accessor: 'internalCode',
        Header: '',
        width: 0,
        maxWidth: 0,
      },

    !['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CD', 'CM', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ','LK','AE'].includes(blCountry)
      ? {
        accessor: 'truckerCode',
        Header:
          oblForm?.pod === 'MYPKG' && blCountry === 'MY'
            ? t('resource_3:ledger_acc_number') + ' '
            : oblForm?.pod === 'MYPEN' && blCountry === 'MY'
              ? t('resource_2:dic_number') + ' '
              : blCountry === 'MY' &&
                (oblForm?.pod === 'MYPGU' || oblForm?.pod === 'MYTPP')
                ? t('resource_3:forward_agent_code') + ' '
                : oblForm?.pod === 'MYKUA' && blCountry === 'MY'
                  ? t('') + ' '
                  : t('resource_2:truckerCode') + ' ',
        width: 178,
        maxWidth: 178,
        Cell: TableCellTrucker,
      }
      : {
        accessor: 'truckerCode',
        Header: '',
        width: 0,
        maxWidth: 0,
      },

    ['SG', 'MY', 'VN'].includes(blCountry)
      ? {
        accessor: 'cntStatus',
        Header: t('resource_1:status'),
        width: 150,
        maxWidth: 150,
      }
      : {
        accessor: 'cntStatus',
        Header: '',
        width: 0,
        maxWidth: 0,
      },
    ['SG', 'MY', 'VN'].includes(blCountry)
      ? {
        accessor: 'requestedOn',
        Header: t('resource_1:requested'),
        width: 150,
        maxWidth: 150,
        Cell: (rowData: any) => {
          const { requestedOn } = rowData.row.original;
          return (
            <span>
              {requestedOn
                ? moment(
                  moment
                    .utc(requestedOn + 'UTC', 'YYYY-MM-DDTHH:mm:SS')
                    .toDate()
                ).format('YYYY-MM-DD HH:mm')
                : ''}
            </span>
          );
        },
      }
      : {
        accessor: 'requestedOn',
        Header: '',
        width: 0,
        maxWidth: 0,
      },
    ['SG', 'MY', 'VN'].includes(blCountry)
      ? {
        accessor: 'approvedRejectedOn',
        Header: 'Approved/Rejected',
        width: 150,
        maxWidth: 150,
        Cell: (rowData: any) => {
          const { approvedRejectedOn } = rowData.row.original;
          return (
            <span>
              {approvedRejectedOn
                ? moment(
                  moment
                    .utc(approvedRejectedOn + 'UTC', 'YYYY-MM-DDTHH:mm:SS')
                    .toDate()
                ).format('YYYY-MM-DD HH:mm')
                : ''}
            </span>
          );
        },
      }
      : {
        accessor: 'approvedRejectedOn',
        Header: '',
        width: 0,
        maxWidth: 0,
      },
  ];

  //const docList = { 101: 'Bill of entry' };
  const [openPopDocsRowId, setOpenPopDocsRowId] = useState<string | null>(null);
  const POPColumns = [
    {
      accessor: 'invno',
      Header: 'Invoice Number',
      width: 200,
      maxWidth: 150
    },
    {
      accessor: 'ccy',
      Header: 'CCY',
      width: 150,
      maxWidth: 100
    },
    {
      accessor: 'amount',
      Header: 'Amount',
      width: 200,
      maxWidth: 150
    },
    {
      accessor: 'invtype',
      Header: 'Invoice Type',
      width: 200,
      maxWidth: 150
    },
    {
      accessor: 'invstatus',
      Header: 'Paid',
      width: 100,
      maxWidth: 80,
      Cell: (rowdata: any) => {
        const { invstatus, invoicestatus } = rowdata.row.original
        return <span>{invstatus && invstatus?.trim() != '' ? invstatus : invoicestatus == 1 ? "Paid" : ""}</span>
      }
    },
    {
      accessor: 'invref',
      Header: 'Payment Reference No',
      width: 250,
      maxWidth: 200
    },
    {
      accessor: 'invatt',
      Header: 'Payment Proof',
      width: 200,
      maxWidth: 150,
			Cell: (rowdata: any) => {
			  const row = rowdata.row.original

			  const activeDocs = Array.isArray(row.popAttachments)
			    ? row.popAttachments.filter(
			        (att: any) => att.active == '1'
			      )
			    : []

			  if (activeDocs.length === 0) {
			    return null
			  }

			  const openDoc = async (popAttId: string | number) => {
			    await openDocumentInNewTab({
			      url: '/api/edo-rest-v2/v2/common/openDocument',
			      params: {
			        id: encryptAndEncode(popAttId),
			        moduleTp: 'PAYMENT_PROOF_NEW',
			        linerId: encryptAndEncode(profileDetails?.partnerId),
			      },
			    })
			  }

			  if (activeDocs.length === 1) {
			    const att = activeDocs[0]

			    return (
			      <span
			        style={{ color: '#2c7be5', cursor: 'pointer' }}
			        onClick={() => openDoc(att.popAttId)}
			      >
			        {att.fileName ?? ''}
			      </span>
			    )
			  }

			  const rowKey = String(rowdata.row.id)

			  return (
			    <OverlayTrigger
			      show={openPopDocsRowId == rowKey}
			      onToggle={(nextShow) =>
			        setOpenPopDocsRowId(nextShow ? rowKey : null)
			      }
			      trigger="click"
			      placement="bottom-end"
			      rootClose
			      container={document.body}
			      popperConfig={{ strategy: 'fixed' }}
			      overlay={
			        <Popover
			          id={`pop-docs-${rowKey}`}
			          className="dropdown-menu-card shadow-sm"
			          onClick={(e) => e.stopPropagation()}
			        >
			          <Popover.Body className="p-0 bg-white">
			            {activeDocs.map((att: any, index: number) => (
			              <div
			                key={att.popAttId ?? index}
			                className={`px-2 py-1${
			                  index < activeDocs.length - 1 ? ' border-bottom' : ''
			                }`}
			              >
			                <span
			                  className="text-primary cursor-pointer fs--1"
			                  onClick={async (e) => {
			                    e.stopPropagation()
			                    await openDoc(att.popAttId)
			                  }}
			                >
			                  {att.fileName ?? ''}
			                </span>
			              </div>
			            ))}
			          </Popover.Body>
			        </Popover>
			      }
			    >
			      <span
			        style={{
			          color: '#2c7be5',
			          cursor: 'pointer',
			          fontWeight:
			            openPopDocsRowId === rowKey ? 'bold' : 'normal',
			        }}
			        onClick={(e) => e.stopPropagation()}
			      >
			        View all docs
			      </span>
			    </OverlayTrigger>
			  )
			}
		}
  ];

  const docAttachmentColumns: IDataTableColumn[] = [
    {
      accessor: 'dndInstructionAttId',
      Header: 'dndInstructionAttId',
    },
    {
      accessor: 'docId',
      Header: t("resource_2:documentName"),
      Cell: (rowData: any) => {
        const { docId, isDropDownDoc, rowNumber, isVerify, dndInstructionAttId } = rowData.row.original;
        const name = currentDocList?.find((v: any) => v?.id === docId)?.name
        return (
          <>
            {(isDropDownDoc && !dndInstructionAttId) ? (
              <div className='d-flex flex-row gx3'>
                <span className="mandatory">*</span>
                <Form.Select
                  onChange={(e) => {
                    const selectedId = Number(e.target.value);
                    const selectedOption = dropdownDocList?.find(option => option.id === selectedId);

                    if (!selectedOption) return;

                    dispatch(updateListByRowNumber({
                      rowNumber: rowNumber,
                      updatedFields: {
                        id: selectedOption.id,
                        name: selectedOption.name
                      },
                      isExtension: doExtension == 'Y'
                    }));
                  }}

                  value={docId !== null && docId !== undefined ? String(docId) : "0"}
                  className={`fs--1 form-control form-select`}
                  // disabled={isView}
                  disabled={!!isVerify || Object.values(loadingFileState).some(
                    (val) => val != 100 && val != -1 && val != undefined
                  ) || (dndInstructionAttId)}
                >
                  <option value="0" disabled>
                    Select a document
                  </option>
                  {dropdownDocList?.map((option: any) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </Form.Select>

              </div>) : (
              <>
                {!(
                  isReceiptAutoPopulated &&
                  Number(docId) == autoPopulateReceiptDocId
                ) && (currentDocList?.find((v: any) => v?.id === docId)?.m === true || (is305Mandate && docId == 305)) ? (
                  <span className='mandatory'>*</span>
                ) : (
                  ''
                )}
                <span title={name || ''}>{name || ''}</span>
              </>
            )}
          </>
        );
      },
      width: 200,
      maxWidth: 180,
    },

    {
      accessor: 'byteArray',
      Header: t("resource_1:upload"),
      Cell: uploadDoument,
      width: 350,
      maxWidth: 350,
    },
    {
      accessor: 'remove',
      Header: '',
      Cell: TableRemoveDoc,
      width: 50,
      maxWidth: 50,
    },
    {
      accessor: 'verify',
      Header: 'Verify',
      Cell: TableVerifyDoc,
      width: 50,
      maxWidth: 50,
    },
    {
      accessor: 'linerEmaiId',
      Header: 'Liner ID',
      Cell: TableLinerId,
      width: 150,
      maxWidth: 150,
    },
    {
      accessor: 'lastUpdatedId',
      Header: 'Last Updated ',
      Cell: TableLastUpdated,
      width: 180,
      maxWidth: 180,
    },
    {
      accessor: 'fileName',
      Header: 'fileName',
    },
  ];

  const receiptDocColumns: IDataTableColumn[] = [
    {
      accessor: 'receiptId',
      Header: 'receiptId',
    },
    {
      accessor: 'receiptNo',
      Header: t('resource_2:receipt_no'),
      width: 200,
      maxWidth: 180,
      Cell: (rowData: any) => {
        const { receiptNo, receiptId } = rowData.row.original;
        if (!receiptNo || !receiptId) {
          return <span>-</span>;
        }

        return (
          <span
            className='text-primary cursor-pointer'
            onClick={() => {
              window.open(
                `${process.env.REACT_APP_CLIENT_APP_HOST}/api/edo-rest-v2/v2/common/openDocument?id=${encryptAndEncode(receiptId)}&moduleTp=PDF_RELEASE_RECEIPTS&linerId=${encryptAndEncode(profileDetails?.partnerType === 'liner' ? profileDetails?.partnerId : selectedLinerId)}&rd=N`,
                '_blank'
              );
            }}>
            {receiptNo}
          </span>
        );
      },
    },
  ];

  const linerDocAttachmentColumns: IDataTableColumn[] = [
    {
      accessor: 'dndInstructionAttId',
      Header: 'dndInstructionAttId',
    },
    {
      accessor: 'docId',
      Header: 'Document Name',
      Cell: (rowData: any) => {
        const { docId, name, m } = rowData.row.original;
        const d216 = linerDocs?.find((x) => x.docId == 216);
        const doWaivedBy216 =
          docId == 206 && !!(d216?.fileName || d216?.serverPath);
          const showMandatory = m && !doWaivedBy216 && !(docId == 208 && disableEmptyYard);
        return (
          <>
            {showMandatory ? (
              <span className='mandatory'>*</span>
            ) : (
              ''
            )}
            <span title={name || ''}>{name || ''}</span>
          </>
        );
      },
      width: 200,
      maxWidth: 180,
    },
    {
      accessor: 'fileName',
      Header: 'Upload',
      width: 300,
      maxWidth: 350,
      Cell: (rowData: any) => {
        const { docId, fileName, loading, id, doReleasePdfId } = rowData.row.original;
        // view only
        if (
          instructionList.filter(
            (v: any) =>
              v?.docId === demurrageViewForm?.dndInstructionId
          ).sort((a: any, b: any) => +(b.blEventId ?? 0) - +(a.blEventId ?? 0))[0]?.event === 'Completed'
          || (demurrageForm.status == 'Completed' || demurrageForm.status?.includes('Rejected'))
          ||
          !(accessGroupLevel[demurrageViewForm.groupLevel] == 'Y' || !accessGroupLevel.includes('Y'))
          ||
          dataCountry !== blCountry || rbac.rbacDetails.demurrageApproveReject !== 'Y'
        ) {
          return <span className={`fs--1 text-primary cursor-pointer`}
												onClick={async () => {

												  if (doReleasePdfId) {

												    await openDocumentInNewTab({
												      url: '/api/edo-rest-v2/v2/common/openDocument',
												      params: {
												        id: encryptAndEncode(doReleasePdfId),
												        moduleTp: 'DO_RELEASE_PDF',
												        linerId: encryptAndEncode(selectedLinerId),
												      },
												    });

												  } else if (id) {

												    await openDocumentInNewTab({
												      url: '/api/edo-rest-v2/v2/common/openDocument',
												      params: {
												        id: encryptAndEncode(id),
												        moduleTp: 'DND_RELEASE_PDF',
												        linerId: encryptAndEncode(selectedLinerId),
												      },
												    });

												  }

												}}
												>
												  {fileName}
												</span>
        }

        return <UploadThing
          name={fileName}
          onOpenDocument={
            !doReleasePdfId && !id
              ? undefined
              : async () => {
                  await openDocumentInNewTab({
                    url: '/api/edo-rest-v2/v2/common/openDocument',
                    params: {
                      id: encryptAndEncode(doReleasePdfId || id),
                      moduleTp: doReleasePdfId ? 'DO_RELEASE_PDF' : 'DND_RELEASE_PDF',
                      linerId: encryptAndEncode(
                        doReleasePdfId ? selectedLinerId : 24118
                      ),
                    },
                  });
                }
          }
          loading={loading}
          fulfilled={function (name: string, serverPath: string, serverName: string): void {
            dispatch(setLinerAttachment({
              docId,
              fileName: name,
              serverPath,
              tempName: serverName,
              loading: 100
            }))
          }}
          failed={function (): void {
            dispatch(setLinerAttachment({
              docId,
              loading: -1,
              fileName: ''
            }))
          }}
          pending={function (loading: number): void {
            dispatch(setLinerAttachment({
              docId,
              loading
            }))
          }}
          clear={function (): void {
            dispatch(setLinerAttachment({
              doReleasePdfId: null,
              docId,
              fileName: '',
              loading: 0,
              serverPath: null,
              tempName: null
            }))
          }}
          selected={function (name: string): void {
            dispatch(setLinerAttachment({
              doReleasePdfId: null,
              docId,
              fileName: name,
              loading: 0,
              serverPath: null,
              tempName: null
            }))
          }}
          fileLimit={(+attachedFileSize) / 1000000}
          fileType={['pdf']}
          labelWidth='250px'
          disabled={docId == 208 && disableEmptyYard}
        />
      }
    },
    {
      accessor: 'cfsName',
      Header:'Empty Yard',
      width: 210,
      maxWidth: 260,
      Cell: TableCellCfsList
    }

  ];


  const docCheckColumns: IDataTableColumn[] = [

    {
      accessor: 'docId',
      Header: '',
      width: 200,
      maxWidth: 230,
    },
    {
      accessor: 'name',
      Header: 'Check List Name',
      Cell: TableCheckListDocName,
      width: 200,
      maxWidth: 230,
    },

    {
      accessor: 'check',
      Header: 'Check',
      Cell: documentCheck,
      width: 150,
      maxWidth: 150,
    },
    {
      accessor: 'remarks',
      Header: 'Remarks ',
      Cell: TableCheckListRemark,
      width: 180,
      maxWidth: 180,
    },
    {
      accessor: 'linerId',
      Header: 'Liner ID',
      width: 150,
      maxWidth: 150,
    },
    {
      accessor: 'checkListUpdated',
      Header: 'Last Updated ',
      width: 180,
      maxWidth: 180,
    }


  ];
  // useEffect(() => {
  //   dispatch(fetchCFSNameByCountry({
  //     country: dataCountry,
  //     // get config, if false send port as
  //     port: ((cfsOrEmptyYardByLocationConfig ?? '').toLowerCase() === 'yes') ? [oblForm.exportLocation].filter(Boolean).join(',') : null
  //   }))
  // }, [dataCountry, oblForm.exportLocation, cfsOrEmptyYardByLocationConfig])



  useEffect(() => {
    if (!blCountry) return
    dispatch(
      getReleaseTypeList(
        { partnerCountry: blCountry, linerId: selectedLinerId }
      )
    );
    if (!language) return
    i18n.changeLanguage(
      `${blCountry}_${language}`
    );
  }, [blCountry, selectedLinerId, language]);

  useEffect(() => {
    if (!disableFields && demurrageViewForm?.list?.length > 0) {
      let tempSelectedTruckerName = {};
      let tempSelectedDate = {};
      let tempselectedPickupLocation = {};
      let tempSelectedTruckerCode = {};
      let tempSelectedtruckerId = {};
      let tempSelectedAttachmentName = {};
      let tempSelectedAttachmentFilePath = {};

      for (var i = 0; i < demurrageViewForm?.list.length; i++) {
        tempSelectedTruckerName = {
          ...tempSelectedTruckerName,
          [demurrageViewForm.list[i]?.containerNo]:
            demurrageViewForm?.list[i]?.truckerName || null,
          location: null,
        };
        tempSelectedDate = {
          ...tempSelectedDate,
          [demurrageViewForm.list[i]?.containerNo]: demurrageViewForm?.list[i]
            ?.pickupDate
            ? moment(
              demurrageViewForm?.list[i]?.pickupDate,
              'YYYY-MM-DD'
            )?.toDate()
            : null,
          intended: null,
        };
        let snContainer = data?.list?.find(
          (v: any) => v.containerNo === demurrageViewForm.list[i]?.containerNo
        );
        if (
          snContainer?.cntStatus === 'Completed' ||
          snContainer?.cntStatus?.includes('Rejected')
        ) {
          tempSelectedTruckerCode = {
            ...tempSelectedTruckerCode,
            [demurrageViewForm.list[i]?.containerNo]:
              snContainer?.truckerCode || null,
            truckerCode: null,
          };
        } else {
          tempSelectedTruckerCode = {
            ...tempSelectedTruckerCode,
            [demurrageViewForm.list[i]?.containerNo]:
              demurrageViewForm?.list[i]?.truckerCode || null,
            truckerCode: null,
          };
        }

        tempSelectedtruckerId = {
          ...tempSelectedtruckerId,
          [demurrageViewForm.list[i]?.containerNo]:
            demurrageViewForm?.list[i]?.truckerId || null,
        };

        tempselectedPickupLocation = {
          ...tempselectedPickupLocation,
          [demurrageViewForm.list[i]?.containerNo]:
            demurrageViewForm?.list[i]?.pickupLocation || null,
          location: null,
        };
      }
      for (var i = 0; i < demurrageViewForm?.attList.length; i++) {
        const key = demurrageViewForm.attList[i]?.dndInstructionAttId ?? demurrageViewForm.attList[i]?.rowNumber ?? null;
        tempSelectedAttachmentName = {
          ...tempSelectedAttachmentName,
          [key]: {
            name: demurrageViewForm?.attList[i]?.fileName || null,
          },
        };
        tempSelectedAttachmentFilePath = {
          ...tempSelectedAttachmentFilePath,
          [key]:
            demurrageViewForm?.attList[i]?.filePath || null,
        };
      }

      dispatch(updateSelectedTruckerName(tempSelectedTruckerName));
      dispatch(updateSelectedDateDV(tempSelectedDate));
      dispatch(updateSelectedtruckerCode(tempSelectedTruckerCode));
      dispatch(updateSelectedtruckerId(tempSelectedtruckerId));

      dispatch(updateSelectedPickupLocation(tempselectedPickupLocation));
      dispatch(updateSelectedAttachmentName(tempSelectedAttachmentName));
      dispatch(
        updateSelectedAttachmentFilePath(tempSelectedAttachmentFilePath)
      );
      setSenderEmail(
        demurrageViewForm?.senderEmail
          ? demurrageViewForm?.senderEmail
          : senderEmail
      );
    } else if (!disableFields && data?.list?.length > 0) {
      let tempSelectedTruckerName = {};
      let tempSelectedDate = {};
      let tempselectedPickupLocation = {};
      let tempSelectedTruckerCode = {};
      let tempSelectedtruckerId = {};

      for (var i = 0; i < data?.list.length; i++) {
        tempSelectedTruckerName = {
          ...tempSelectedTruckerName,
          [data.list[i]?.containerNo]: data.list[i]?.truckerName || null,
          location: null,
        };
        tempSelectedDate = {
          ...tempSelectedDate,
          [data.list[i]?.containerNo]: data.list[i]?.pickupDate
            ? moment(data.list[i]?.pickupDate, 'YYYY-MM-DD')?.toDate()
            : selectedDate[data.list[i]?.containerNo] ?? null,
          intended: null,
        };
        tempSelectedTruckerCode = {
          ...tempSelectedTruckerCode,
          [data.list[i]?.containerNo]: data.list[i]?.truckerCode || null,
          truckerCode: null,
        };

        tempSelectedtruckerId = {
          ...tempSelectedtruckerId,
          [data.list[i]?.containerNo]: data.list[i]?.truckerId || null,
        };

        tempselectedPickupLocation = {
          ...tempselectedPickupLocation,
          [data.list[i]?.containerNo]: data.list[i]?.pickupLocation || selectedDefaultPickupLocation || null,
          location: null,
        };
      }

      dispatch(updateSelectedTruckerName(tempSelectedTruckerName));
      dispatch(updateSelectedDateDV(tempSelectedDate));
      dispatch(updateSelectedtruckerCode(tempSelectedTruckerCode));
      dispatch(updateSelectedtruckerId(tempSelectedtruckerId));

      dispatch(updateSelectedPickupLocation(tempselectedPickupLocation));
    } else {
      if (!disableFields && getUnprefixedPathname().split('/')[3] === 'instruction') {
        let tempSelectedTruckerCode = {};
        let tempselectedPickupLocation = {};

        for (var i = 0; i < data?.list?.length; i++) {
          tempSelectedTruckerCode = {
            ...tempSelectedTruckerCode,
            [data.list[i]?.containerNo]: data.list[i]?.truckerCode || null,
            truckerCode: null,
          };
          tempselectedPickupLocation = {
            ...tempselectedPickupLocation,
            [data.list[i]?.containerNo]: selectedDefaultPickupLocation || null,
            location: null,
          };
        }

        dispatch(updateSelectedtruckerCode(tempSelectedTruckerCode));
        dispatch(updateSelectedPickupLocation(tempselectedPickupLocation));
      } else {
        dispatch(updateSelectedtruckerCode({}));
        dispatch(updateSelectedPickupLocation({}));
      }

      dispatch(updateSelectedTruckerName({}));
      dispatch(updateSelectedDateDV({ intended: null }));
      dispatch(updateSelectedtruckerId({}));
      dispatch(updateSelectedAttachmentName({}));
      dispatch(updateSelectedAttachmentFilePath({}));
    }
  }, [disableFields, demurrageViewForm, data, selectedDefaultPickupLocation]);


  const approveRejectAccess = useMemo(() => !(instructionList.filter(
    (v: any) =>
      v?.docId === demurrageViewForm?.dndInstructionId
  ).sort((a: any, b: any) => +(b.blEventId ?? 0) - +(a.blEventId ?? 0))[0]?.event === 'Completed'
    || (demurrageForm.status == 'Completed' || demurrageForm.status?.includes('Rejected'))
    ||
    !(accessGroupLevel[demurrageViewForm.groupLevel] == 'Y' || !accessGroupLevel.includes('Y'))
    ||
    dataCountry !== blCountry || rbac.rbacDetails.demurrageApproveReject !== 'Y')
    , [instructionList, demurrageViewForm, dataCountry,
      blCountry, rbac.rbacDetails.demurrageApproveReject, demurrageForm.status])
  const [extensionTypeOption, setExtensionTypeOption] = useState<any[]>([]);


  useEffect(() => {
    if (blCountry && linerId) {
      dispatch(extensionTypeList({ partnerCountry: blCountry, linerId }))
        .unwrap()
        .then((options: any[]) => setExtensionTypeOption(options));
    }
  }, [blCountry, linerId, dispatch]);

    useEffect(() => {
    if (blCountry && linerId) {
      dispatch(getUnstuffingTypeList({ partnerCountry: blCountry, linerId }))
        .unwrap()
        .then((options: any[]) => setUnstuffingTypeOptions(options));
    }
  }, [blCountry, linerId, dispatch]);

  const [selectedNeedExtensionFor, setSelectedNeedExtensionFor] = useState<any>({});

  // Initialize selectedNeedExtensionFor with all container numbers on fresh load
  useEffect(() => {
    if (data?.list?.length > 0 && Object.keys(selectedNeedExtensionFor).length === 0) {
      const initial: { [key: string]: string } = {};
      data.list.forEach((item: any) => {
        initial[item.containerNo] = '';
      });
      setSelectedNeedExtensionFor(initial);
    }
  }, [data]);

  const allSameValue = (() => {
    const values = Object.values(selectedNeedExtensionFor || {});
    return values.length > 0 && values.every(v => v === values[0]) ? values[0] : '';
  })();

  const isUnstuffingDisabled = (profileDetails.partnerType === 'customer' && disableFields) ||
    (profileDetails.partnerType === 'liner' && !((dataCountry === blCountry &&
      rbac.rbacDetails.demurrageApproveReject === 'Y' &&
      !(
        isProcessing === 'Y' &&
        !linerDocs?.find((i) => i.docId == 206)?.serverPath &&
        !linerDocs?.find((i) => i.docId == 206)?.id
      )) && !(instructionList
        .filter(
          (v: any) =>
            v?.docId === demurrageViewForm?.dndInstructionId
        )
        .sort((a: any, b: any) => +(b.blEventId ?? 0) - +(a.blEventId ?? 0))[0]?.event === 'Completed'
        ||
        (demurrageForm.status == 'Completed' || demurrageForm.status?.includes('Rejected'))) && ((accessGroupLevel[demurrageViewForm.groupLevel] == 'Y' || !accessGroupLevel.includes('Y')))))

  useEffect(() => {
    const partnerId = profileDetails.partnerType === 'liner'
      ? profileDetails.partnerId
      : selectedLinerId;
    if (!partnerId || !blCountry) return;
    const payload = {
      partnerId: partnerId,
      countryCode: blCountry,
      actionType: "REJECT",
      groupLevel: demurrageForm.groupLevel,
      name: "DEMURRAGE INSTRUCTION"

    }
    dispatch(getApprovalConfigByInstructionName(payload))
      .then((res: any) => {
        if (res.payload.defaultValue >= 0 && res.payload.approvalList.length > 0) {
          setApprovalLevelsOptions(res.payload.approvalList);
          setValue("selectedApprovalLevel", res.payload.defaultValue);
        }
      })
      .catch(() => {
        setApprovalLevelsOptions([]);
      })
  }, [profileDetails.partnerId, blCountry, demurrageForm.groupLevel])
  return (
    <Card style={{ minHeight: '100%' }}>
      <UnsavedChangesModal
        show={showModal}
        onHide={handleStayOnPage}
        onConfirm={handleLeavePage}
      />
      <Card.Header
        className='d-flex align-items-center border-bottom bg-white sticky-top'
        style={{ zIndex: 10 }}>
        <FontAwesomeIcon
          icon={faArrowAltCircleLeft}
          className='text-warning cursor-pointer fa-lg me-1 mb-2'
          // onClick={_onCloseForm}
          onClick={handleBack}
        />
        <div className="d-flex align-items-center flex-wrap gap-7 mb-1">
          <div className='d-flex align-items-center gap-5 mb-1'>
            <h2 className="fs-0 text-primary mb-0 mb-lg-0">
              {t('resource_2:demurrageInstruction')}
            </h2>

          {displayNumber && (
            <div className="d-flex align-items-center">
              <span className="text-muted me-2">BL No.</span>
              <span className="fw-bold me-2">
                {displayNumber}
              </span>
              <button
                className="btn btn-link p-0"
                onClick={handleCopyBL}
                title="Copy BL number"
              >
                <FontAwesomeIcon icon={faCopy} className="text-primary" />
              </button>
            </div>
          )}
          </div>
          {templateList && !demurrageViewForm.dndInstructionId && templateList.length > 0 && profileDetails?.partnerType !== 'liner' && instructionLoading===false && (
          <div className="d-flex align-items-left ms-3">
           <Dropdown>
           <Dropdown.Toggle
            bsPrefix='toggle'
            as={Link}
            to='#!'
            className='pe-0 ps-2 nav-link '
            style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }} // right align
          >
            <Flex
              direction='row'
              justifyContent='end'
              alignItems='end'
              alignContent=''
              inline=''
              wrap=''
              className='justify-content-end'
              style={{ width: '100%' }}
              breakpoint=''
            >
              <Button
                style={{ width: 'auto', marginLeft: 'auto', display: 'block' }}
                variant='ms-3 btn btn-falcon-primary z-inxe-agent btn-sm'
                size='lg'
                title='Download Document'
                className='ms-3'
              >
                <FontAwesomeIcon
                  icon={faDownload}
                  className='me-2 '
                  style={{ fontSize: '14px', color: '#f5822a' }}
                  title='Download Document'
                />
                <span style={{fontSize:12}}>{t('resource_2:downloadTemplate')}</span>  
              </Button>
            </Flex>
          </Dropdown.Toggle>
              <Dropdown.Menu>
                {templateList.map((tpl: any) => (
                  <Dropdown.Item
                    key={tpl.code}
										onClick={async () => {
										  setValue('doNumber', tpl.doNumber ?? '');

										  await openDocumentInNewTab({
										    url: '/api/edo-rest-v2/v2/common/openDocument',
										    params: {
										      id: encryptAndEncode(tpl.code),
										      moduleTp: 'INSTRUCTION_DOC',
										      linerId: encryptAndEncode(selectedLinerId),
										    },
										  });
										}}
                  >
                    {tpl.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
        </div>
      

       {/*  {tncUrl && (
         <span className='badge bg-light mb-2' style={{color:'#5e6e82'}}>
            <a
              href={tncUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-link ms-3"
              style={{ color: '#2c7be5', textDecoration: 'none', fontSize:"14px", padding:"0px" }}
              onMouseOver={e => { e.currentTarget.style.textDecoration = 'underline'; }}
              onMouseOut={e => { e.currentTarget.style.textDecoration = 'none'; }}
            >
              <FontAwesomeIcon icon={faDownload} className="text-warning" style={{ padding: '0px 3px' }} /> 
                {t('resource_2:clickHere')} 
            </a> to download Guarantee Form 
            </span>
      )}  */}
    </Card.Header>
      <Card.Body
        className={
          blCountry === 'MY' &&
            (oblForm?.pod === 'MYBTU' ||
              oblForm?.pod === 'MYKCH' ||
              oblForm?.pod === 'MYBKI')
            ? 'd-none'
            : 'd-block'
        }>
        <div className='container'>
           {profileDetails?.partnerType === 'customer' &&
            blCountry === 'US' || blCountry === 'CA' ? (
            <>
              <label className='form-label'>
                Available only for imports into USA
              </label>
              <p style={{ fontSize: '12px' }}>
                Let us know the intended pickup date for your shipment and we
                will revert with the invoice for the PORT demurrage within some
                minutes.
              </p>{' '}
            </>
          ) : (
            ''
          )}
          <Form onSubmit={(e) => {
            e.preventDefault()
            if (ShowInvoiceModal) {
              setSubmitOn(true)
              return;
            }
            onSubmit()
          }} autoComplete='off' ref={formRef}>
            <div className='row'>
              {t('resource_message:demurrageInstruction') != '' && (
                <div className='col-lg-12 mb-1'>
                  {t('resource_message:demurrageInstruction') != '' && (
                    <div className='col-lg-12 mb-1'>
                      <Form.Label style={{ color: '#f5822a' }}>
                        <ul style={{ paddingLeft: '15px' }}>
                          {t('resource_message:demurrageInstruction')
                            .split('\n')
                            .map((v: any) => (
                              <li>{v}</li>
                            ))}
                        </ul>
                      </Form.Label>
                    </div>
                  )}
                </div>
              )}


              {blCountry === 'MY' && (
                <div className='col-lg-6 mb-3'>
                  <Form.Group controlId='carrierHaulage.pod'>
                    <Form.Label className='fs--1'>
                      {t('resource_3:Port_of_destination')}
                      <span>
                        {' '}
                        <FontAwesomeIcon
                          icon={faInfoCircle}
                          title=' '
                          className='me-2'
                        />
                      </span>
                    </Form.Label>
                    <Form.Control
                      type='POD'
                      size='sm'
                      //   disabled={disableFields}
                      disabled={true}
                      value={oblForm?.pod || ''}
                    />
                    <div className='invalid-feedback'></div>
                  </Form.Group>
                </div>
              )}

              {['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CD', 'CM', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ','LK','AE'].includes(blCountry) ? (
                <div className='col-lg-5 mb-3 d-none' style={{ zIndex: 15 }}>
                  <Form.Group controlId='invoiceChanges.releaseType'>
                    <Form.Label className='fs--1'>
                      <span className='mandatory'>*</span>
                      {t('resource_2:releaseType')}&nbsp;
                    </Form.Label>
                    <Form.Select
                      aria-label={t('resource_2:releaseType')}
                      {...register('releaseType')}
                      className='fs--1'
                      disabled={disableFields}
                      value={releaseType}
                      onChange={(e) => {

                        setReleaseType(e.target.value);
                        _onReleaseTypeChange(e.target.value);
                        dispatch(setDirty());
                      }}>
                      {releaseTypeList.map((option: any) => (
                        <option key={option.value} value={option.value}>
                          {option.text}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div>
              ) : (
                ''
              )}
              {['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CD', 'CM', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ','LK','AE'].includes(blCountry) ? (
                ''
              ) : (
                <div className='col-lg-6 mb-3'>
                  <Form.Group controlId='carrierHaulage.senderEmail'>
                    <Form.Label className='fs--1'>
                      <span className='mandatory'>*</span>
                      {t('resource_2:senderEmail')}
                      <span>
                        {' '}
                        <FontAwesomeIcon
                          icon={faInfoCircle}
                          title='We will send the invoice for the demurrage within some minutes to this email address.'
                          className='me-2'
                        />
                      </span>
                    </Form.Label>
                    <Form.Control
                      {...register('senderEmail')}
                      className={`fs--1 form-control ${errors.senderEmail ? 'is-invalid' : ''
                        }`}
                      type='email'
                      onChange={(e) => {
                        setSenderEmail(e.target.value);
                        dispatch(setDirty());
                      }}
                      size='sm'
                      disabled={disableFields}
                      value={
                        disableFields
                          ? demurrageViewForm?.senderEmail || ''
                          : senderEmail
                      }
                    />
                    <div className='invalid-feedback'>
                      {errors.senderEmail?.message?.toString()}
                    </div>
                  </Form.Group>
                </div>
              )}
              {profileDetails.partnerType == 'liner' ? (
                <div className='col-lg-6 mb-3' style={{ zIndex: 1 }}>
                  <Form.Group controlId='carrierHaulage.requestedPartnerNm'>
                    <Form.Label className='fs--1'>
                      <span className='mandatory'>*</span>
                      {t('resource_2:companyName')}
                      <span>
                        {' '}
                        {/* <FontAwesomeIcon
                        icon={faInfoCircle}
                        title='We will send the invoice for the demurrage within some minutes to this email address.'
                        className='me-2'
                      /> */}
                      </span>
                    </Form.Label>
                    <Form.Control
                      {...register('requestedPartnerName')}
                      className={`fs--1 form-control ${errors.requestedPartnerName ? 'is-invalid' : ''
                        }`}
                      type='text'
                      // onChange={(e) => setSenderEmail(e.target.value)}
                      size='sm'
                      disabled={disableFields}
                      value={
                        disableFields
                          ? demurrageViewForm?.requestedPartnerName || ''
                          : requestedPartnerName
                      }
                    />
                    <div className='invalid-feedback'>
                      {errors.requestedPartnerName?.message?.toString()}
                    </div>
                  </Form.Group>
                </div>
              ) : (
                <></>
              )}

              {(!disableFields && ['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CM', 'CD', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ','LK','AE'].includes(blCountry) && showPickupLocationFields) ? (
                <div className='col-lg-6 mb-3 '>
                  <Form.Group>
                    <Form.Label className='fs--1'>
                      {t('resource_7:pickupLocationForAllContainer')}{' '}
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        title='Change Pickup location for all conatainer'
                        className='me-2'
                      />
                    </Form.Label>
                    <div>
                      {['KE', 'TG','CI', 'TZ', 'MZ', 'CD', 'CM', 'UG', 'BJ','LK'].includes(blCountry) || (blCountry == 'ZA' && selectedLinerId == '24118') ?
                        <div style={{ zIndex: 999 }}>
                          <AsyncSelect
                            menuPortalTarget={document.body}

                            classNames={{
                              control: (state) => {
                                return `dropControl fs--1 asyncDropField m-0 p-0
                          form-control ${state.isDisabled ? 'disabledField' : ''}
                          ${state.isFocused ? 'focusField' : ''}`;
                              },
                            }}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              control: (base) => ({}),
                            }}
                            cacheOptions
                            onChange={(e: any) => {
                              let containers: any = {};
                              let emptyContainers: any = {};
                              let pickupDateConatiner: any = {};

                              for (let k of data.list) {
                                if (k?.containerNo) {
                                  if (
                                    e?.cfsName ===
                                    selectedPickupLocation?.[k?.containerNo]
                                  ) {
                                  } else {
                                    containers[k.containerNo] = e?.cfsName;
                                    emptyContainers[k.containerNo] = null;
                                  }
                                }
                                if (!e?.cfsName) {
                                  pickupDateConatiner[k.containerNo] = null;
                                }
                              }

                              dispatch(
                                updateSelectedPickupLocation({
                                  ...selectedPickupLocation,
                                  ...containers,
                                  location: e?.cfsName,
                                })
                              );
                              dispatch(
                                updateSelectedTruckerName({
                                  ...selectedTruckerName,
                                  ...emptyContainers,
                                })
                              );
                              dispatch(
                                updateSelectedtruckerId({
                                  ...selectedtruckerId,
                                  ...emptyContainers,
                                })
                              );
                              dispatch(
                                updateselectedInternalCode({
                                  ...selectedinternalCode,
                                  ...emptyContainers,
                                })
                              );
                              dispatch(
                                updateSelectedDateDV({
                                  ...selectedDate,
                                  ...pickupDateConatiner,
                                })
                              );
                              dispatch(setDirty());
                            }}
                            value={{
                              label: selectedPickupLocation?.location || '',
                              value: selectedPickupLocation?.location || '',
                            }}
                              
                            loadOptions={locationOptions}
                            isDisabled={disableFields}
                            isClearable={true}
                            noOptionsMessage={({ inputValue }) => {
                              if (!inputValue) return 'Type to search';
                              return 'No options';
                            }}
                          />
                        </div>
                        : <Form.Select
                          {...register('pickupLocation')}
                          disabled={disableFields}
                          value={selectedPickupLocation?.location || ''}
                          onChange={(e) => {
                            let containers: any = {};
                            let emptyContainers: any = {};
                            let pickupDateConatiner: any = {};
                            if (e.target.value) {
                              for (let k of data.list) {
                                if (k?.containerNo) {
                                  if (
                                    e.target.value ===
                                    selectedPickupLocation?.[k?.containerNo]
                                  ) {
                                  } else {
                                    containers[k.containerNo] = e.target.value;
                                    emptyContainers[k.containerNo] = null;
                                  }
                                  if (e.target.value === '1002') {
                                    pickupDateConatiner[k.containerNo] =
                                      selectedDate?.intended;
                                  } else {
                                    pickupDateConatiner[k.containerNo] = null;
                                  }
                                }
                              }
                            }
                            dispatch(
                              updateSelectedPickupLocation({
                                ...selectedPickupLocation,
                                ...containers,
                                location: e.target.value,
                              })
                            );
                            dispatch(
                              updateSelectedTruckerName({
                                ...selectedTruckerName,
                                ...emptyContainers,
                              })
                            );
                            dispatch(
                              updateSelectedtruckerId({
                                ...selectedtruckerId,
                                ...emptyContainers,
                              })
                            );
                            dispatch(
                              updateselectedInternalCode({
                                ...selectedinternalCode,
                                ...emptyContainers,
                              })
                            );
                            dispatch(
                              updateSelectedDateDV({
                                ...selectedDate,
                                ...pickupDateConatiner,
                              })
                            );
                            dispatch(setDirty());
                          }}
                          className='fs--1 form-control  form-select'>
                          {
                            <>
                              {pickUpLocation.map((option: any) => (
                                <option key={option.value} value={option.value}>
                                  {option.text}
                                </option>
                              ))}
                            </>
                          }
                        </Form.Select>}
                    </div>
                  </Form.Group>
                </div>
              ) : (
                ''
              )}
              {((showUnstuffingTypeConfig ?? "").toLowerCase() == 'yes') && (
                <div className='col-lg-6 mb-3'>
                  <Form.Group>
                    <Form.Label className='fs--1'>
                      <span className="mandatory">*</span>
                      Unstuffing Type For All Container
                    </Form.Label>
                    <Form.Select
                      {...register("unstuffingType")}
                      className={`fs--1 form-control form-select ${errors.unstuffingType ? 'is-invalid' : ''
                        }`}
                      style={{ fontSize: "12px" }}
                      disabled={isUnstuffingDisabled}
                    >
                      {unstuffingTypeOptions?.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.text}
                        </option>
                      ))}
                    </Form.Select>
                    <div className='invalid-feedback'>
                      {errors.unstuffingType?.message?.toString()}
                    </div>
                  </Form.Group>
                </div>)}

              {blCountry === 'US' || blCountry === 'CA' ||
                (!disableFields && ['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CM', 'CD', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ','LK','AE'].includes(blCountry)) ||
                (blCountry === 'MY' && oblForm?.pod === 'MYPEN') ? (
                <div className='col-lg-6 mb-3'>
                  <Form.Group controlId='carrierHaulage.IntendedDate'>
                    <Form.Label className='fs--1'>
                      {t('resource_7:IntendedDateForAllContainer')}{' '}
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        title='We will calculate the storage/demurrage up to this date.'
                        className='me-2'
                      />
                    </Form.Label>
                    <div className='releaseDate'>
                      <DatePicker
                        selected={selectedDate?.intended}
                        onChange={(date) => {
                          let containers: any = {};
                          if (date) {
                            for (let k of data.list) {
                              if (k?.containerNo) {
                                if (['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CM', 'CD', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ','LK','AE'].includes(blCountry)) {
                                  if (
                                    selectedPickupLocation?.[k?.containerNo] !==
                                    '1001'
                                  ) {
                                    containers[k.containerNo] = date;
                                  } else {
                                    containers[k.containerNo] = null;
                                  }
                                } else {
                                  containers[k.containerNo] = date;
                                }
                              }
                            }
                          }

                          dispatch(
                            updateSelectedDateDV({
                              ...selectedDate,
                              ...containers,
                              intended: date,
                            })
                          );
                          dispatch(setDirty());
                        }}
                        className='fs--2 form-control'
                        timeIntervals={5}
                        dateFormat={getDateFormat()}
                        isClearable={clearable}
                        popperProps={{
                          strategy: 'fixed',
                        }}
                        minDate={new Date()}
                        //disabled={DatePickDisabled}
                        //value={value}
                        disabled={disableFields}

                      />
                    </div>
                  </Form.Group>
                </div>
              ) : (
                ''
              )}

              {['SG', 'MY', 'VN'].includes(blCountry) ? (
                <div className='col-lg-6 mb-3' style={{ zIndex: 1 }}>
                  <Form.Group controlId='carrierHaulage.IntendedDate'>
                    <Form.Label className='fs--1'>
                      {oblForm?.pod === 'MYPKG' && blCountry === 'MY'
                        ? t('resource_7:ledger_acc_number') + ' '
                        : oblForm?.pod === 'MYPEN' && blCountry === 'MY'
                          ? t('resource_5:dic_number') + ' '
                          : blCountry === 'MY' &&
                            (oblForm?.pod === 'MYPGU' || oblForm?.pod === 'MYTPP')
                            ? t('resource_7:forward_agent_code') + ' '
                            : oblForm?.pod === 'MYKUA' && blCountry === 'MY'
                              ? t('') + ' '
                              : t('resource_7:IntendedDateForAllContainerSG') + ' '}
                      {/*  <FontAwesomeIcon
                        icon={faInfoCircle}
                        title='We will calculate the storage/demurrage up to this date.'
                        className='me-2'
                      /> */}
                    </Form.Label>
                    <div>
                      {
                        <Form.Control
                          size='sm'
                          type='text'
                          className={
                            oblForm?.pod === 'MYKUA' && blCountry === 'MY'
                              ? 'd-none'
                              : 'd-block'
                          }
                          onChange={(e) => {
                            let containers: any = {};

                            for (let k of data.list) {
                              if (k?.containerNo) {
                                containers[k.containerNo] = e.target.value;
                              }
                            }

                            dispatch(
                              updateSelectedtruckerCode({
                                ...selectedTruckerCode,
                                ...containers,
                                // intended: date,
                                truckerCode: e.target.value,
                              })
                            );
                            dispatch(setDirty());
                          }}
                          value={selectedTruckerCode?.truckerCode}
                          disabled={disableFields}
                        />
                        /* <DatePicker
                        truckerCode
                        selected={selectedDate?.intended}
                        onChange={(date) => {
                          let containers: any = {};
                          if (date) {
                            for (let k of data.list) {
                              if (k?.containerNo) {
                                containers[k.containerNo] = date;
                              }
                            }

                            setPayloadList(
                              data?.list?.map((f: any) => ({
                                ...f,
                                pickupDate: moment(date + ' UTC').format(
                                  'yyyy-MM-DD'
                                ),
                              }))
                            );
                          }

                          dispatch(
                            updateSelectedDateDV({
                              ...selectedDate,
                              ...containers,
                              intended: date,
                            })
                          );
                        }}
                        className='fs--2 form-control'
                        timeIntervals={5}
                        dateFormat='MM/dd/yyyy'
                        isClearable={clearable}
                        popperProps={{
                          strategy: 'fixed',
                        }}
                        // onChange={(e) => SetIntendedDate(e.target.value)}
                        //disabled={DatePickDisabled}
                        //value={value}
                        disabled={disableFields}
                      /> */
                      }
                    </div>
                  </Form.Group>
                </div>
              ) : (
                ''
              )}

              <div className='col-lg-6' style={{ zIndex: 1 }}>

                {(DoExtensonCheckBoxShow ?? "").toLowerCase() == 'yes' && (
                  <Controller
                    name="doExtension"
                    control={control}
                    render={({ field }) => (
                      <Form.Check
                        type="checkbox"
                        id="do-extension-checkbox"
                        label="DO extension"
                        // checked={doExtension == 'Y'}
                        checked={field.value === 'Y'}
                        onChange={e => {
                          // setDoExtension(e.target.checked ? 'Y' : 'N')
                          field.onChange(e.target.checked ? 'Y' : 'N');
                          // setIsSavedDoNumber(false)
                        }}
                        // onClick={(e:any)=>{
                        //   dispatch(getDeliveryOrderDataForExtension({ id: recentId?.docId, selectedLinerId, country: blCountry, liner: selectedLinerId }))
                        // }}
                        disabled={disableFields || decrptdoc || recentId}
                      // className="mt-2"
                      />
                    )}
                  />
                )}
              </div>
              {doExtension == 'Y' && (
                <div className='col-lg-6 mb-3'>
                  <span className="mandatory">*</span>
                  <Form.Label className='fs--1'>
                    DO No
                  </Form.Label>
                  {
                    <Form.Control
                      {...register('doNumber')}
                      value={watch('doNumber')}
                      // className={`fs--1 ${errors.vesselName ? 'is-invalid' : ''
                      //   }`}
                      className={`fs--1 ${errors.doNumber?.message?.toString() ? "is-invalid" : ""}`}
                      disabled={disableFields || isSavedDoNumber}
                    // onChange={e => setDoNumber(e.target.value)}

                    >
                    </Form.Control>
                  }
                  <div className='invalid-feedback d-block'>
                    {errors.doNumber?.message?.toString()}
                  </div>
                </div>)}
              {/* Right column */}
              {/* <div className='col-lg-6  mb-3 ' style={{ zIndex: 1 }}>

                  {blCountry === 'MZ' && doExtension == 'Y' && (
                    <div style={{ minWidth: 350, maxWidth: 450 }}>
                      <Form.Group controlId="overStayExtension.needExtensionFor">
                        <Form.Label className="fs--1 mb-1">
                          {t('resource_5:needExtensionForAllContainer')}
                        </Form.Label>
                        <Form.Select
                          value={String(allSameValue)}
                          disabled={disableFields}
                          onChange={e => {
                            const newValue = e.target.value;
                            const keys = data?.list?.map((item: any) => item.containerNo) || [];
                            setSelectedNeedExtensionFor((prev: any) => {
                              const newObj: { [key: string]: string } = {};
                              keys.forEach(key => {
                                newObj[key] = newValue;
                              });
                              return newObj;
                            });
                            keys.forEach(containerNo => {
                              dispatch(updateSelectedContainerNo({ containerNo, needExtensionFor: newValue }));
                            });
                            dispatch(setDirty());
                          }}
                        >
                          {extensionTypeOption.map((option: any) => (
                            <option key={option.value} value={String(option.value)}>
                              {option.text}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </div>
                  )}
                </div> */}

              {!disableFields && (['GB', 'JO', 'AU', 'NZ', 'HK', 'PK','ZA', 'AO', 'LK','AE'].includes(blCountry)) ? (
                <div className='col-lg-6 mb-3'>
                  <Form.Group>
                    <Form.Label className='fs--1'>
                      {t('resource_7:truckerNameForAllContainer')}{' '}
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        title='Change trucker name for all conatainer'
                        className='me-2'
                      />
                    </Form.Label>
                    <div style={{ zIndex: 999 }}>
                      <AsyncSelect
                        menuPortalTarget={document.body}
                        noOptionsMessage={({ inputValue }) => {
                          return inputValue ? 'No options' : 'Type to search';
                        }}
                        classNames={{
                          control: (state) => {
                            return `dropControl fs--1 asyncDropField m-0 p-0
                          form-control ${state.isDisabled ? 'disabledField' : ''
                              }
                          ${state.isFocused ? 'focusField' : ''}`;
                          },
                        }}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({}),
                        }}
                        cacheOptions
                        onChange={(e: any) => {
                          let containers: any = {};
                          let emptyContainers: any = {};
                          let truckerIdConatiner: any = {};
                          let pickupDateConatiner: any = {};
                          if (e?.truckerName) {
                            for (let k of data.list) {
                              if (k?.containerNo) {
                                if (
                                  selectedPickupLocation?.[k?.containerNo] !==
                                  '1002' &&
                                  !(
                                    impHaulage === 'Carrier Haulage' &&
                                    ['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CM', 'CD', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ','LK','AE'].includes(blCountry)
                                  )
                                ) {
                                  containers[k.containerNo] = e?.truckerName;
                                  emptyContainers[k.containerNo] = e?.internalCode;
                                  truckerIdConatiner[k.containerNo] =
                                    e?.truckerId;
                                }
                                if (
                                  selectedPickupLocation?.[k?.containerNo] ===
                                  '1002' || (blCountry=='ZA' && linerId=='24118') 
                                ) {
                                  pickupDateConatiner[k.containerNo] =
                                    selectedDate?.intended;
                                } else {
                                  pickupDateConatiner[k.containerNo] = null;
                                }
                              }
                            }
                            dispatch(setDirty());
                          }
                          dispatch(
                            updateSelectedTruckerName({
                              ...selectedTruckerName,
                              ...containers,
                              location: e?.truckerName,
                            })
                          );
                          dispatch(
                            updateSelectedtruckerId({
                              ...selectedtruckerId,
                              ...truckerIdConatiner,
                            })
                          );
                          dispatch(
                            updateselectedInternalCode({
                              ...selectedinternalCode,
                              ...emptyContainers,
                            })
                          );
                          console.log("pickupDateConatiner::",pickupDateConatiner)
                          dispatch(
                            updateSelectedDateDV({
                              ...selectedDate,
                              ...pickupDateConatiner,
                            })
                          );
                        }}
                        value={{
                          label: selectedTruckerName?.location || '',
                          value: selectedTruckerName?.location || '',
                        }}
                        loadOptions={promiseOptions}
                        isDisabled={
                          (impHaulage === 'Carrier Haulage' && ['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CM', 'CD', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ','LK','AE'].includes(blCountry))
                          || disableFields
                        }
                        isClearable={true}
                      />
                    </div>
                  </Form.Group>
                </div>
              ) : (
                ''
              )}
              {profileDetails?.partnerType === 'liner' &&
                (
                  linerConfig.crrUnpaidHardStop == 'Y' ||
                  linerConfig.crrUnpaidSoftStop == 'Y'
                ) &&
                releasePOPData.length > 0 &&
                <ToggleDiv
                  className='col-lg-12 mb-2 demmurageTable'
                  style={{ zIndex: 1 }}
                  showText={'Click here to view Payment details'}
                  hideText={'Click here to hide Payment details'}
                  initial={releasePOPData.findIndex((i) => i.invoicestatus != 1) != -1}
                >

                  <DataTable
                    data={releasePOPData}
                    gridName='RELEASE_POP'
                    columns={POPColumns}
                    sortable={false}
                    searchable={false}
                    showColumnFilter={false}
                    selection={false}
                    perPage={10}
                    pagination={false}
                    showExport={false}
                    uniqueFilterKey='releasepop'
                    autoHeight={true}
                    staticHiddenCols={[]}
                    maxHeight='250px'
                  />
                </ToggleDiv>
              }

              {profileDetails?.partnerType === 'customer' &&
                blCountry === 'US' || blCountry == 'CA' ? (
                <label className='form-label' style={{ color: '#f5822a' }}>
                  Please submit the Intended Pickup Date only for those
                  containers for which the Demurrage Invoice is needed
                </label>
              ) : (
                ''
              )}
              <div
                className='col-lg-12 mb-2 demmurageTable'
                style={{ zIndex: 1 }}>
                {(data.list?.length > 0 && blCountry) ? (
                  <DataTable
                    data={data.list}
                    gridName='RELEASE_INTSRUCTION'
                    columns={contactDetailsColumns}
                    sortable={false}
                    searchable={false}
                    showColumnFilter={false}
                    selection={false}
                    perPage={10}
                    pagination={false}
                    showExport={false}
                    uniqueFilterKey='releaseInstruction'
                    autoHeight={true}
                    staticHiddenCols={
                      (() => {
                        let hidden =
                          blCountry === 'US' || blCountry == 'CA'
                            ? [
                              'blContainerId',
                              'pickupLocation',
                              'truckerName',
                              'internalCode',
                              'truckerId',
                              'cntStatus',
                              'requestedOn',
                              'approvedRejectedOn',
                              'truckerCode',
                            ]
                            : ['SG', 'VN'].includes(blCountry) ||
                              (blCountry === 'MY' &&
                                (oblForm?.pod === 'MYPKG' ||
                                  oblForm?.pod === 'MYPGU' ||
                                  oblForm?.pod === 'MYTPP'))
                              ? [
                                'blContainerId',
                                'pickupLocation',
                                'truckerName',
                                'internalCode',
                                'truckerId',
                                'IntendedDate',
                              ].concat(
                                !isEdit && !disableFields
                                  ? ['cntStatus', 'requestedOn', 'approvedRejectedOn']
                                  : []
                              )
                              : blCountry === 'MY' && oblForm?.pod === 'MYPEN'
                                ? [
                                  'blContainerId',
                                  'pickupLocation',
                                  'truckerName',
                                  'internalCode',
                                  'truckerId',
                                ].concat(
                                  !isEdit && !disableFields
                                    ? ['cntStatus', 'requestedOn', 'approvedRejectedOn']
                                    : []
                                )
                                : blCountry === 'MY' && oblForm?.pod === 'MYKUA'
                                  ? [
                                    'blContainerId',
                                    'pickupLocation',
                                    'truckerName',
                                    'internalCode',
                                    'truckerId',
                                    'truckerCode',
                                    'IntendedDate',
                                  ].concat(
                                    !isEdit && !disableFields
                                      ? ['cntStatus', 'requestedOn', 'approvedRejectedOn']
                                      : []
                                  )
                                  : ['GB', 'JO', 'AU', 'NZ', 'HK', 'PK','AE'].includes(blCountry) || blCountry == 'ZA' || blCountry == 'AO'
                                    ? [
                                      'blContainerId',
                                      'truckerCode',
                                      'cntStatus',
                                      'requestedOn',
                                      'approvedRejectedOn',
                                    ]
                                    : ['KE', 'TG','CI', 'CD', 'CM', 'UG', 'TZ', 'MZ', 'BJ','LK','AE'].includes(blCountry) //|| (blCountry == 'ZA' && selectedLinerId == '24118')
                                      ? [
                                        'blContainerId',
                                        'truckerCode',
                                        'cntStatus',
                                        'requestedOn',
                                        'approvedRejectedOn',
                                        'truckerId',
                                        'truckerCode',
                                        'truckerName',
                                        'internalCode',
                                      ]
                                      : ['blContainerId'];

                        const allowedCountries = ['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CM', 'CD', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ','LK','AE'];

                        if (blCountry && (!allowedCountries.includes(blCountry) || !showPickupLocationFields) && !hidden.includes('pickupLocation')) {

                          hidden.push('pickupLocation');
                        }


                        return hidden;
                      })()
                    }
                  />
                ) : (
                  ''
                )}
              </div>

              {['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CD', 'CM', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ','LK','AE'].includes(blCountry) && docAttachment.list && docList?.length ? (
                <div className='col-lg-12 mt-2 mb-2 demmurageTable'>
                  {(!disableFields) && <span className='badge bg-secondary mb-2'>
                    {t('resource_message:docInfo')}{' '}
                  </span>}

               {/*  {tncUrl && (
                    <span className='badge bg-light mb-2' style={{color:'#5e6e82'}}>
                        <a
                          href={tncUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-link ms-3"
                          style={{ color: '#2c7be5', textDecoration: 'none', fontSize:"14px", padding:"0px" }}
                          onMouseOver={e => { e.currentTarget.style.textDecoration = 'underline'; }}
                          onMouseOut={e => { e.currentTarget.style.textDecoration = 'none'; }}
                        >
                          <FontAwesomeIcon icon={faDownload} className="text-warning" style={{ padding: '0px 3px' }} /> 
                            {t('resource_2:clickHere')} 
                        </a> to download Guarantee Form 
                        </span>
                    )}  */}
                  
                  {(!disableFields) && !!dropdownDocList?.length && (
                    <div>
                      <Button
                        variant='falcon-primary'
                        size='sm'

                        onClick={(e: any) => {
                          if (!dropdownDocList || dropdownDocList.length === 0) return;


                          // const rowNumber = crypto.randomUUID();
                          // const selectedDoc = { rowNumber:rowNumber, ...dropdownDocList[0]};
                          if (additionalDocCount < 10) {
                            dispatch(addDocument({ isExtension: doExtension == 'Y' }));
                          }
                        }}
                        disabled={!dropdownDocList?.length || additionalDocCount >= 10}
                        className=" mb-2"
                        style={{ width: "max-content" }}
                      >
                        <FontAwesomeIcon className="me-1" icon={faAdd} /> Documents
                      </Button>
                    </div>
                  )}
                  <div className='col-lg-12 mt-2 mb-2 demmurageTable'>
                    <DataTable
                      // data={docAttachment?.list ?? []}
                      data={doExtension == 'Y' ? extensionAttData.list : docAttachment?.list ?? []}
                      gridName='RELEASE_ATTACHMENT'
                      columns={docAttachmentColumns}
                      sortable={false}
                      searchable={false}
                      showColumnFilter={false}
                      selection={false}
                      perPage={100}
                      pagination={false}
                      showExport={false}
                      uniqueFilterKey='releaseAttachment'
                      autoHeight={true}
                      staticHiddenCols={accessGroupLevel.includes('Y') ? ['dndInstructionAttId', 'fileName', 'remove'] : ['dndInstructionAttId', 'fileName', 'verify', 'linerEmaiId', 'lastUpdatedId']}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
              {autoPopulateReceiptOnDO && !receiptDocListLoading && !!receiptDocList?.length && (
                <div className='col-lg-12 mt-2 mb-2 demmurageTable'>
                  <span className='badge bg-secondary mb-2'>
                    {t('resource_2:payment_receipts')}
                  </span>
                  <DataTable
                    data={receiptDocList ?? []}
                    gridName='RELEASE_PAYMENT_RECEIPT'
                    columns={receiptDocColumns}
                    sortable={false}
                    searchable={false}
                    showColumnFilter={false}
                    selection={false}
                    perPage={100}
                    pagination={false}
                    showExport={false}
                    uniqueFilterKey='releasePaymentReceipt'
                    autoHeight={true}
                    staticHiddenCols={['receiptId']}
                  />
                </div>
              )}
              {autoPopulateReceiptOnDO && !receiptDocListLoading && !receiptDocList?.length && !disableFields && (
                <div className='text-danger fs--1 mt-1 mb-2'>
                  No payment receipt is available for this BL.
                </div>
              )}
              {accessGroupLevel.includes('Y') && checkListData?.length > 0 &&
                <div className='demmurageTableCheckList'>
                  <DataTable
                    data={checkListData ?? []}
                    gridName='CHECK_LIST'
                    columns={docCheckColumns}
                    sortable={false}
                    searchable={false}
                    showColumnFilter={false}
                    selection={false}
                    perPage={10}
                    pagination={false}
                    showExport={false}
                    uniqueFilterKey='releaseAttachment'
                    autoHeight={true}
                    staticHiddenCols={['docId']}

                  />
                </div>
              }
              {['ZA', 'AO', 'GB', 'JO', 'KE', 'TG','CI', 'CD', 'CM', 'TZ', 'MZ', 'UG', 'AU', 'NZ', 'HK', 'PK', 'MZ', 'BJ','LK','AE'].includes(blCountry) &&
                (
                  profileDetails.partnerType == 'liner'
                  || demurrageViewForm.status == 'Completed'
                  || (linerDocs.some((data)=>data?.isRejected && !!data.filePath))
                ) &&
                linerDocs?.length > 0 &&
                <div className='col-lg-12 mt-2 mb-2 demmurageTable'>
                  {approveRejectAccess && <span className='badge bg-secondary mb-2'>
                    {t('resource_message:docInfo')}{' '}
                  </span>}

                  
                  
                  <DataTable
                    data={linerDocs}
                    gridName='LINER_RELEASE_ATTACHMENT'
                    columns={linerDocAttachmentColumns}
                    sortable={false}
                    searchable={false}
                    showColumnFilter={false}
                    selection={false}
                    perPage={10}
                    pagination={false}
                    showExport={false}
                    uniqueFilterKey='releaseAttachment'
                    autoHeight={true}
                    staticHiddenCols={rbac.rbacDetails.cfsEmptyName == 'Y' ? ['dndInstructionAttId'] : ["cfsName", 'dndInstructionAttId']}
                  />
                </div>
              }
              {(
                dataCountry === blCountry &&
                (doGeneratedAmsConfig ?? "") == 'Y' &&
                profileDetails.partnerType === 'liner' &&
                rbac.rbacDetails.demurrageApproveReject === 'Y'
              ) && (
                  <div className='col-lg-12' style={{ zIndex: 1 }}>
                    <Form.Check
                      type="checkbox"
                      id="do-generated-checkbox"
                      label="DO generated on AMS"
                      checked={isProcessing === 'Y' || doGeneratedAMS === 'Y'}
                      onChange={e => {
                        if (isProcessing === '') {
                          openDoGeneratedDialog()
                        };
                        setDoGeneratedAMS(prev => (prev === 'Y' ? 'N' : 'Y'));
                      }}
                      disabled={
                        profileDetails.partnerType != 'liner' ||
                        !linerDocs?.find((i) => i?.docId == 206) ||
                        isProcessing === 'Y' ||
                        isProcessing === 'N' ||
                        (demurrageViewForm?.status === 'Completed' ||
                          demurrageViewForm?.status?.includes('Rejected')) ||
                        !(accessGroupLevel[demurrageViewForm.groupLevel] === 'Y' || !accessGroupLevel.includes('Y')) ||
                        instructionList
                          .filter((v: any) => v?.docId === demurrageViewForm?.dndInstructionId)
                          .sort((a: any, b: any) => +(b.blEventId ?? 0) - +(a.blEventId ?? 0))[0]?.event === 'Completed'
                      }
                    />
                  </div>
                )
              }
              {
                (rbac.rbacDetails.rejectionLevelSelection == 'Y' && approvalLevelsOptions.length > 0 && (accessGroupLevel[demurrageViewForm.groupLevel] == 'Y' || !accessGroupLevel.includes('Y'))) &&
                <>
                  <div className='col-lg-6 mb-3'>
                    <Form.Group controlId='carrierHaulage.userRemark'>
                      <Form.Label className='fs--1'>
                        {t('resource_2:approval_level')}
                      </Form.Label>
                      <Form.Select
                        aria-label="Config"
                        className="fs--1"
                        size="lg"
                        value={watch("selectedApprovalLevel") ?? ""}
                        disabled={approvalLevelsOptions.length <= 1}
                        onChange={(e: any) => {
                          setValue("selectedApprovalLevel", e?.target?.value)
                        }}
                      >
                        <option value="" hidden={true}>
                          Select Approval Level
                        </option>
                        {
                          approvalLevelsOptions.map(({ label, value }: { label: string, value: number }) => (
                            <option key={value} value={value}>
                              {label}
                            </option>
                          ))
                        }
                      </Form.Select>
                    </Form.Group>
                  </div>
                </>
              }
              <div className='col-lg-6 mb-3'>
                <Form.Group controlId='carrierHaulage.userRemark'>
                  <Form.Label className='fs--1'>
                    {t('resource_2:userRemark')}
                  </Form.Label>
                  <Form.Control
                    className={'fs--1 form-control'}
                    value={userRemarks}
                    maxLength={200}
                    as='textarea'
                    {...register('userRemarks')}
                    onChange={(e) => {
                      setUserRemarks(e.target.value);
                      dispatch(setDirty());
                    }}

                    disabled={
                      profileDetails.partnerType == 'liner' ||
                      disableFields ||
                      demurrageViewForm.status === 'Completed'
                    }
                  />
                </Form.Group>
              </div>

              {rbac.rbacDetails.demurrageApproveReject === 'Y' ||
                disableFields ? (
                <div className='col-lg-6 mb-3'>
                  <Form.Group controlId='carrierHaulage.rejectionRemark'>
                    <Form.Label className='fs--1'>
                      {t('resource_1:rejectRemark')}
                    </Form.Label>
                    <Form.Control
                      className={'fs--1 form-control'}
                      value={remarks}
                      as='textarea'
                      onChange={(e) => {
                        setRemarks(e.target.value);
                        dispatch(setDirty());
                      }}
                      disabled={
                        demurrageViewForm.status == 'Completed' || demurrageViewForm.status?.includes('Rejected')
                          ? true
                          : rbac.rbacDetails.demurrageApproveReject === 'Y'
                            ? false
                            : disableFields
                      }
                    />
                  </Form.Group>
                </div>
              ) : (
                <></>
              )}
            </div>


            {showDoUploadStatus && (
              <>
                <div className="row">
                  <div className='col-lg-6 mb-3'>
                    <Form.Group controlId='carrierHaulage.doUploadStatus'>
                      <Form.Label className='fs--1 d-flex align-items-center'>

                        DO Upload Status
                        <FontAwesomeIcon
                          icon={faInfoCircle}
                          title='Status of DO sent to Terminal, if failed then switch app to reprocess'
                          className='ms-2'
                        />
                      </Form.Label>

                      <Form.Control
                        className='fs--1 form-control'
                        value={doUploadStatus}
                        maxLength={200}
                        {...register('doUploadStatus')}
                        onChange={(e) => {
                          setDoUploadStatus(e.target.value);
                          dispatch(setDirty());
                        }}
                        disabled={true}

                      />

                    </Form.Group>
                  </div>

                  <div className='col-lg-6 mb-3'>
                    <Form.Group controlId='carrierHaulage.doIntegrationRemarks'>
                      <Form.Label className='fs--1'>
                        DO Integration Remarks
                      </Form.Label>
                      <Form.Control
                        className={'fs--1 form-control'}
                        value={doIntegrationRemarks}
                        maxLength={200}
                        as='textarea'
                        {...register('doIntegrationRemarks')}
                        onChange={(e) => {
                          setDoIntegrationRemarks(e.target.value);
                          dispatch(setDirty());
                        }}

                        disabled={true}

                      />
                    </Form.Group>
                  </div>
                </div>
              </>
            )}

            <div className='d-flex justify-content-center align-items-center mt-4'>
              {
                dataCountry === blCountry &&
                  rbac.rbacDetails.demurrageApproveReject === 'Y' &&
                  !(
                    isProcessing === 'Y' &&
                    !linerDocs?.find((i) => i.docId == 206)?.serverPath &&
                    !linerDocs?.find((i) => i.docId == 206)?.id
                  ) ? (
                  <>
                    {
              instructionList.filter(
                          (v: any) =>
                            v?.docId === demurrageViewForm?.dndInstructionId
                        ).sort((a,b)=>+(b.blEventId??0) - (a.blEventId??0))[0]?.event === 'Completed'
                        ||
                        (demurrageForm.status == 'Completed' || demurrageForm.status?.includes('Rejected')) ? (
                        <></>
                      ) : (
                        <>
                          <div className='d-flex justify-content-center align-items-center'>
                            {(accessGroupLevel[demurrageViewForm.groupLevel] == 'Y' || !accessGroupLevel.includes('Y')) && <>

                              <Button
                                disabled={
                                  demurrageViewForm?.status === 'Completed' ||
                                    demurrageViewForm?.status?.includes('Rejected')
                                    ? disableFields
                                    : false
                                }
                                onClick={(e) => {
                                  onApproveReject('A', 'CONTAINER_RELEASE');
                                }}
                                variant='success'
                                className='me-2 approve'
                                size='sm'>
                                <FontAwesomeIcon
                                  icon={faCheck}
                                  className='me-2 approve'
                                />
                                {t('resource_1:approve')}
                              </Button>

                              <Button
                                variant='danger'
                                className='reject me-2'
                                size='sm'
                                disabled={
                                  demurrageViewForm?.status === 'Completed' ||
                                    demurrageViewForm?.status?.includes('Rejected')
                                    ? disableFields
                                    : false
                                }
                                onClick={(e) => {
                                  onApproveReject('R', 'CONTAINER_RELEASE');
                                }}>
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  className='me-2   reject'

                                />
                                {t('resource_1:reject')}
                              </Button>
                              {rbac.rbacDetails.snoozeCUD === 'Y' && !location.pathname.includes('/bl') ? <SnoozedToButton blNum={AESDecrypt(blNum)} blEventId={blEventId_docInsDashboard} /> : ""}
                            </>
                            }
                          </div>
                        </>
                      )}
                  </>
                ) : (
                  !disableFields && (
                    <div className='d-flex justify-content-center align-items-center'>
                      {submitFlag ? (
                        <Lottie
                          animationData={infiniteLoop}
                          loop={true}
                          style={{ height: '80px', width: '80px' }}
                        />
                      ) : (
                        <>
                          <Button
                            className='me-2'
                            variant='falcon-primary'
                            size='sm'
                            type='submit'
                            disabled={(() => {
                              if (Object.values(loadingFileState).some(
                                (val) => val != 100 && val != -1 && val != undefined
                              )) return true
                              if (isSarsCustomsReleaseBlocked) return true

                              if (autoPopulateReceiptOnDO) {
                                if (receiptDocListLoading) return true;
                                if (!receiptDocList?.length) {
                                  const docAttachmentKey = doExtension == 'Y' ? extensionAttData : docAttachment;
                                  const viewFormAttKey = doExtension == 'Y' ? demurrageViewForm.extensionAttList : demurrageViewForm.attList;
                                  const proofOfPaymentDoc = docAttachmentKey?.list?.find(
                                    (x) => Number(x.docId) == autoPopulateReceiptDocId
                                  );
                                  if (!proofOfPaymentDoc) return true;

                                  const key = proofOfPaymentDoc?.dndInstructionAttId ?? proofOfPaymentDoc?.rowNumber ?? null;
                                  const isProofOfPaymentMissing = (
                                    !selectedAttachmentName?.[key]
                                    || ((
                                      loadingFileState[key] != 100
                                      || !serverFilePath[key]
                                    )
                                      && ((viewFormAttKey.findIndex(
                                        (i) => (i?.docId == proofOfPaymentDoc?.docId) && i?.dndInstructionAttId
                                      ) == -1)
                                        || loadingFileState[key] == -1)
                                    )
                                  );
                                  if (isProofOfPaymentMissing) return true;
                                }
                              }

                              if (blCountry == 'US' || blCountry == 'CA') {
                                if (!senderEmail || senderEmail?.trim?.() == '') return true
                                return !data.list
                                  .some((v: any) =>
                                    selectedDate?.[v?.containerNo] ? true : false
                                  )
                              }
                              const doNumber = watch('doNumber')
                              if ((DoExtensonCheckBoxShow ?? "").toLowerCase() == 'yes' && doExtension === 'Y' && (!doNumber || doNumber?.trim?.() == '')) return true

                              if (['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CD', 'CM', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ','LK','AE'].includes(blCountry)) {

                                const docAttachmentKey = doExtension == 'Y' ? extensionAttData : docAttachment;
                                const viewFormAttKey = doExtension == 'Y' ? demurrageViewForm.extensionAttList : demurrageViewForm.attList;

                                if (docAttachmentKey?.list?.length == 0) return true
                                if (docAttachmentKey.list.filter((x) => {
                                  if (
                                    isReceiptAutoPopulated &&
                                    Number(x.docId) == autoPopulateReceiptDocId
                                  ) {
                                    return false;
                                  }
                                  return x.m || (x.docId == 305 && is305Mandate);
                                }).findIndex(
                                  (d) => {
                      
                                    // const key = d?.dndInstructionAttId ?? (d?.isDropDownDoc ? d?.rowNumber ?? null : null);
                                    const key = d?.dndInstructionAttId ?? d?.rowNumber ?? null;
                                    console.log(key, selectedAttachmentName?.[key], loadingFileState, serverFilePath[key], viewFormAttKey)

                                    // check for file name  
                                    return (
                                      !selectedAttachmentName?.[key]

                                      || ((
                                        // check for uploaded files
                                        loadingFileState[key] !== 100
                                        || !serverFilePath[key]
                                      )

                                        // check for submitted files
                                        && ((viewFormAttKey.findIndex((i) => (i?.docId == d?.docId)
                                          && i?.dndInstructionAttId) == -1)
                                          || loadingFileState[key] == -1)
                                      ))
                                  }) != -1) return true
                                  // console.log(PickupLocationValidityFlag,'<<PickupLocationValidityFlag');
                                if (['ZA', 'AO', 'GB', 'UG', 'KE', 'TG','CI', 'CD', 'CM', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK', 'BJ','LK','AE'].includes(blCountry)) return !PickupLocationValidityFlag

                                const usedContainers = Object.entries(selectedPickupLocation)
                                  .filter(([key, val]) => val && val != '' && key != 'location')
                                  .map((([key, _]) => key))
                                if (usedContainers.length < 1) return true
                                if (['KE', 'TG','CI', 'CM', 'CD', 'UG', 'TZ', 'MZ', 'BJ','LK'].includes(blCountry) || (blCountry == 'ZA' && selectedLinerId == '24118')) return usedContainers.some((c) => !selectedDate?.[c])
                              }

                              if (blCountry === 'MY' && oblForm?.pod === 'MYKUA') return false

                              if (blCountry === 'MY' && oblForm?.pod === 'MYPEN') {
                                if (!senderEmail || senderEmail?.trim?.() == '') return true
                                return !data.list
                                  .map((v: any) =>
                                    selectedDate?.[v?.containerNo] &&
                                      selectedTruckerCode?.[v?.containerNo]
                                      ? true
                                      : false
                                  ).includes(true)
                              }
                              if (['SG', 'MY', 'VN'].includes(blCountry)) {
                                if (!senderEmail || senderEmail?.trim?.() == '') return true
                                return !data.list
                                  .map((v: any) =>
                                    selectedTruckerCode?.[v?.containerNo]
                                      ? true
                                      : false
                                  )
                                  .includes(true)
                              }
                              return true
                            })()}>
                            <FontAwesomeIcon icon={faSave} className='me-2' />
                            {t('resource_1:submit')}
                          </Button>
                          <Button
                            className='me-2'
                            variant='falcon-danger'
                            size='sm'
                            onClick={resetForm}
                            style={{ zIndex: 1 }}>
                            <FontAwesomeIcon icon={faRedo} className='me-2' />
                            {t('resource_1:reset')}
                          </Button>
                          {
                            rbac.rbacDetails.saveAsDraft === 'Y'&& ((newEvent || recentId?.event == 'Not Submitted') && (currStatus != 'Submitted') && (!currStatus.includes('Rejected')))&&
                            <Button
                              className='me-2'
                              variant='falcon-primary'
                              size='sm'
                              type='submit'
                              onClick={() => {
                                setIsDraft(true)
                              }}
                              disabled={
                                (
                                  () => {

                                    // if loading
                                    if (Object.values(loadingFileState).some(
                                      (val) => val != 100 && val != -1 && val != undefined
                                    )) return true

                                    if (autoPopulateReceiptOnDO && receiptDocListLoading) return true;

                                    if (Object.values(selectedPickupLocation).length < 2
                                    ) return true

                                    if (userRemarks.trim() != '')
                                      return false

                                    // if (['ZA', 'AO', 'GB', 'UG', 'CD', 'CM', 'KE', 'TG','CI', 'TZ', 'MZ', 'JO', 'AU', 'NZ', 'HK', 'PK'].includes(blCountry)) {
                                    //   if (Object.values(selectedPickupLocation).findIndex(n => n && n !== '0') != -1)
                                    //     return false

                                    //   if (Object.values(loadingFileState).some((val) => val == 100))
                                    //     return false
                                    // }

                                    if (['SG', 'MY', 'VN'].includes(blCountry)) {
                                      if (senderEmail && senderEmail?.trim?.() != '')
                                        return false

                                      if (data.list
                                        .findIndex((v: any) =>
                                          selectedTruckerCode?.[v?.containerNo] &&
                                          selectedTruckerCode?.[v?.containerNo].trim() != ''
                                        ) != -1)
                                        return false
                                    }

                                    if (blCountry == 'US' || blCountry == 'MY' || blCountry == 'CA') {
                                      if (senderEmail && senderEmail?.trim?.() != '')
                                        return false

                                      if (data.list
                                        .findIndex((v: any) =>
                                          selectedDate?.[v?.containerNo]
                                        ) != -1)
                                        return false
                                    }

                                    return false
                                  }
                                )()
                              }>
                              <FontAwesomeIcon icon={faFolder} className='me-2' color='#f5822a' />
                              {t('resource_3:saveAsDraft')}
                            </Button>}
                        </>
                      )}


                    </div>
                  )
                )}
              {
                (currStatus == 'Submitted' || currStatus?.includes('Rejected') || currStatus == 'Draft') &&
                  profileDetails.partnerType != 'liner' &&
                  disableFields && (demurrageViewForm?.requestedPartnerId == profileDetails?.partnerId) ? (
                  <div className='d-flex justify-content-center align-items-center'>
                    <Button
                      variant='falcon-primary'
                      size='sm'
                      className='me-2'
                      onClick={async () => {
                        if (
                          (linerConfig.crrUnpaidHardStop == 'Y'
                            || linerConfig.crrUnpaidSoftStop == 'Y')) {
                          dispatch(clearUnpaidData())
                          const linerId =
                            profileDetails.partnerType === 'liner'
                              ? profileDetails.partnerId
                              : selectedLinerId;

                          if (await dispatch(getUnpaidInvoice(
                            {crrPopAttStop: linerConfig.crrPopAttStop, blid: AESDecrypt(blNum) ?? demurrageForm.blId ?? blidDocHistory, country: blCountry, linerId: linerId ,location:null},
                            
                          )).unwrap().then(
                            ({ unpaid, attachment }: any) => {
                              if ((unpaid && unpaid.length > 0) ||
                                (attachment && attachment.length > 0)
                              ) {
                                return true
                              }
                            }
                          )) {
                            navigate(`${getUnprefixedPathname().split('/')[0]}/bl/${encodeURIComponent(
                              blNum || ''
                            )}/${AESEncrypt('804')}/unpaid`)
                            return
                          }
                        }
                        setDisableFields(false);
                        setIsEdit(true);
                      }}>
                      <FontAwesomeIcon icon={faEdit} className='me-2' />
                      {t('resource_1:edit')}
                    </Button>
                  </div>
                ) : (
                  <></>
                )}
            </div>

          </Form>
        </div>
      </Card.Body>
      <Modal
        show={ShowInvoiceModal && submitOn}
        onHide={() => setSubmitOn(false)}
        backdrop
        keyboard={false}
        centered
        animation={false}
      >
        <Modal.Header closeButton>
          {/*  <Modal.Title>Invoice Instruction</Modal.Title> */}
        </Modal.Header>

        <Modal.Body className="text-center">
          <div>
            {(blCountry == 'ZA' || blCountry == 'AO' || blCountry == 'AE') ? "Storage Overstay Instruction Invoice Instruction is not submitted for " : "Detention/Demurrage Invoice Instruction is not submitted for "}
            <b>{displayNumber || 'this BL'}</b>.
            <br />
            {(blCountry == 'ZA' ||blCountry == 'AO' || blCountry == 'AE') ? "Do you want to submit Storage Overstay Instruction? " : "Do you want to submit Detention/Demurrage Invoice Instruction?"}
          </div>
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <Button variant="secondary" onClick={handleInvoiceModalNo}>
            No
          </Button>
          <Button variant="primary" onClick={handleInvoiceModalYes}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDoGeneratedDialog}
        onHide={closeDoGeneratedDialog}
        centered
        size='lg'
      >
        <Modal.Header className='p-2 pb-1' closeButton>
          <Modal.Title>
            DO generated on AMS
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div>
            Are you sure you want to change the request status to Processing? Once updated, further edits will not be allowed. Click 'OK' to contine
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button variant="secondary" onClick={() => {
            setShowDoGeneratedDialog(false)
            setDoGeneratedAMS('N')
          }}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => {
            if (isProcessing === '') {
              updateIsProcessing({ demmurrageId: decrptdoc, blId: AESDecrypt(blNum) ?? demurrageForm?.blId })
              setShowDoGeneratedDialog(false)
              setDoGeneratedAMS('Y')
              setTimeout(() => {
                dispatch(
                  getInstructionList({
                    blNum: AESDecrypt(blNum),
                    country: profileDetails.partnerType == "liner" ? dataCountry : blCountry
                  })
                );
                dispatch(updateDashbaordRefresh(true))
              }, 3500);
              handleBack()
            }
          }}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>

    </Card>

  );
};

export default ReleaseInstruction;
